window.trace = function () {
  var pop = $("#tracer");
  if (pop.length === 0) {
    var tmp =
      '<div id="tracer" style="position:fixed;bottom:0;right:0;width:200px;height:100px;padding:5px;border:1px solid grey;border-radius:5px;background-color:rgba(255,255,255,0.6);z-index:99999;">';
    tmp +=
      '<div style="height:100%;overflow:auto;font-size:12px;line-height:15px;"></div>';
    tmp += "</div>";
    pop = $(tmp);
    $("body").append(pop);
  }
  var div = pop.find("div"),
    arr = Array.from(arguments);
  div.prepend(
    '<span style="display:block;margin-top:2px;border-top:1px dashed #ccc;padding:2px;padding-bottom:0;color:black;">' +
      JSON.stringify(arr) +
      "</span>"
  );
  var spans = div.find("span");
  if (spans.length > 20) {
    spans.last().remove();
  }
};

var LGEAPPreturnSmComQRcode;
var LGEAPPreturnSmQRcode;
~(function () {
  var compareIds = "";
  function init() {
    vcui.require(
      ["ui/tab", "ui/selectbox", "ui/modal", "libs/pinchzoom-2.0.0.min"],
      function () {
        etc.init();
        page.init();
      }
    );
  }

  var page = {
    pocketIntro: function () {
      var doc = $(document);
      doc.on("click", ".btn-appdown", function (e) {
        e.preventDefault();
        var $this = $(e.currentTarget);
        goAppUrl(location.href);
      });
    },
    noDataPage: function () {
      var doc = $(document);
      var homeBtn = $(".btn-goto-sm");
      var qrBtn = $(".btn-goto-qr");
      var homeUrl = $(".list-item.home a").attr("href");
      if (isApp()) {
        qrBtn.show();
      } else {
        qrBtn.hide();
      }
      homeBtn.on("click", function () {
        location.href = homeUrl;
      });
      qrBtn.on("click", function () {
        location.href = vcui.uri.updateQueryParam(homeUrl, "move", "web");
      });
    },
    main: function () {
      var doc = $(document);
      var ajaxUrl = doc.find(".container").data("ajaxUrl");
      var referrerUrl = document.referrer;
      if (referrerUrl.indexOf("homepage") !== -1) {
        if (referrerUrl.indexOf("status=lg") !== -1) {
          lgkorUI.setStorage("storeReferrer", "lg");
        } else {
          lgkorUI.setStorage("storeReferrer", "bs");
        }
      }

      // BTOCSITE-23820 start
      if(vcui.isEmpty(etc.getParameterByName("agree"))){
        //최초 진입 시 앱설치 팝업
        etc.appInstallPop();
      }
      // BTOCSITE-23820 end

      lgkorUI.requestAjaxDataPost(ajaxUrl, {}, function (result) {
        var data = result.data;
        var storeModeInfo = data.storeModeInfo;
        var tit = doc.find(".m-tit");
        var goToStore = doc.find(".go-to-store");
        var hPoint = doc.find(".h-point");
        var hLogin = doc.find(".h-login");
        var qrArea = doc.find(".m-qr");
        var storeName = storeModeInfo.storeName;
        var storeId = storeModeInfo.storeId;
        var storeMapYn = storeModeInfo.storeMapYn;
        var point = "";
        // 로그인/비로그인 시
        if (data.memberInfo !== undefined) {
          point = data.memberInfo.myMembershipPoint;
          hPoint.children(".h-point-text").html(point + "<span>P</span>");
          hPoint.show();
          hLogin.hide();
        } else {
          hPoint.hide();
          hLogin.show();
        }
        //로그인
        hLogin.on("click", function (e) {
          etc.loginChk(undefined, undefined, undefined, e.currentTarget); // BTOCSITE-77491 웹접근성
        });
        // 맵 유무
        if (storeMapYn === "Y") {
          doc.find(".btn-location").attr("href", data.mapUrl);
        } else {
          doc.find(".btn-location").closest("li").remove();
        }
        //맵핑
        tit.children("span").eq(0).text(storeName);
        doc.find(".btn-wishlist").attr("href", data.wishUrl);
        doc.find(".btn-popularity").attr("href", data.nowRecommendUrl);
        doc.find(".btn-event").attr("href", data.eventUrl);

        if (isApp()) {
          goToStore.children("a").attr("href", data.bestshopUrl + "?status=lg");
        } else {
          var storeReferrer = lgkorUI.getStorage("storeReferrer");
          if (storeReferrer == undefined || storeReferrer !== "bs") {
            goToStore
              .children("a")
              .attr("href", data.bestshopUrl + "?status=lg");
          } else {
            goToStore
              .children("a")
              .attr("href", data.bestshopUrl + "?status=bs");
          }
        }
        //qr 체크 위한 데이터
        var contents = doc.find(".contents");
        contents.data("storeMapYn", storeMapYn);
        contents.data("myMembershipPoint", point);
        contents.data("shopName", storeName);
        contents.data("storeId", storeId);
        if (
          vcui.Cookie.get("STORE_GUIDE") === "" &&
          (vcui.Cookie.get("__LGAPP_DLOG_STORE__") !== "" || isApp())
        ) {
          //BTOCSITE-25104 start
          //가이드 페이지
          /*if (!!vcui.modal) {
            etc.appGuidePop();
          }*/
          //BTOCSITE-25104 end
        } else if (etc.getParameterByName("move") === "web") {
          // 웹 qr 유입 qr 실행
          window.history.replaceState(
              "",
              "",
              vcui.uri.updateQueryParam(location.href, "move", "end")
          );

          // BTOCSITE-23820 start
          // etc.gateQrCall();
          infoAgree.qrAgreeInit();
        }

        if(etc.getParameterByName("agree") === "Y"){
          infoAgree.returnUrl(function () {
            infoAgree.qrAgreeInit();
          });
        }
        // BTOCSITE-23820 end

        doc.find(".main-contents").show();
      });
    },
    gate: function () {
      var doc = $(document);
      var container = doc.find(".container");
      var ajaxUrl = container.data("ajaxUrl");
      var storeId = container.data("storeId") || "";
      var modelId = container.data("modelId") || "";
      var modelUrlPath = container.data("modelUrlPath") || "";
      var specUrl = container.data("specUrl") || "";
      var CbtnInfo = doc.find(".btn-c-info");
      var Cinfo = CbtnInfo.next(".c-info");
      var popCookieName = "SM_INFLOW_" + container.data("storeId");

      // 제품 정보를 준비중 입니다. 영역 show/hide
      if (etc.getParameterByName("similarFlag") === "Y") {
        doc.find(".msg-ing-banner").show();
      } else {
        doc.find(".msg-ing-banner").hide();
      }

      //단골매장
      if (
        vcui.Cookie.get("SM_QR_INFLOW_CNT") == 5 &&
        vcui.Cookie.get(popCookieName) === ""
      ) {
        var loginUrl = "/sso/member/login?state=";
        var checkUrl = "/mkt/api/bestshop/storemode/retrieveBookmarkStore";
        var bookmarkUrl = "/support/bookmarkStore.lgajax";
        var sendata = {
          checked: true,
          shopId: storeId,
        };

        $("#popup-frequent").on("click", ".btn.gray", function (e) {
          vcui.Cookie.set(popCookieName, "hide");
        });
     
       
       // BTOCSITE-64387 공통(7/7) memberinfo, logininfo api 개선
          var isLogin = digitalData.userInfo.isLogin;
          if (!isLogin) {
            doc.find("#popup-frequent").vcModal("show");
            doc.find("#popup-frequent .btn.mix").on("click", function (e) {
              lgkorUI.confirm(
                "로그인 후 이용가능 합니다.<br>로그인하시겠어요? ",
                {
                  title: "",
                  cancelBtnName: "아니오",
                  okBtnName: "네",
                  ok: function () {
                    location.href = vcui.uri.updateQueryParam(
                      loginUrl,
                      "state",
                      encodeURIComponent(location.pathname + location.search)
                    );
                  },
                }
              );
            });
          } else {
            lgkorUI.requestAjaxDataPost(
              checkUrl,
              { storeId: storeId },
              function (result) {
                var chk = result.data[0].bookmarkStoreYn;
                if (chk === "Y") {
                } else {
                  doc.find("#popup-frequent").vcModal("show");
                  doc
                    .find("#popup-frequent .btn.mix")
                    .on("click", function (e) {
                      e.preventDefault();
                      lgkorUI.requestAjaxDataPost(
                        bookmarkUrl,
                        sendata,
                        function (result) {
                          if (result.data.success == "N") {
                            lgkorUI.confirm(
                              "로그인 후 이용가능 합니다.<br>로그인하시겠어요? ",
                              {
                                title: "",
                                cancelBtnName: "아니오",
                                okBtnName: "네",
                                ok: function () {
                                  location.href = vcui.uri.updateQueryParam(
                                    loginUrl,
                                    "state",
                                    encodeURIComponent(
                                      location.pathname + location.search
                                    )
                                  );
                                },
                              }
                            );
                          } else {
                            doc.find("#popup-frequent").vcModal("close");
                            $(window).trigger(
                              "toastshow",
                              "단골매장이 등록되었습니다."
                            );
                          }
                        }
                      );
                    });
                }
              }
            );
          }
          // BTOCSITE-64387 공통(7/7) memberinfo, logininfo api 개선 end
       
      }

      // BTOCSITE-23820 start
      if(vcui.isEmpty(etc.getParameterByName("agree"))){
        //최초 진입 시 앱설치 팝업
        etc.appInstallPop();
      }

      //위시리스트 등록
      doc.find(".btn-wishlist").on("click", function (e) {
        e.preventDefault();
        var $this = $(this);
        var doc = $(document);
        var loginUrl = "/sso/member/login?state=";
        var moveUrl = location.pathname + location.search;

        // BTOCSITE-64387 공통(7/7) memberinfo, logininfo api 개선 - Ajax 삭제
          var isLogin = digitalData.userInfo.isLogin;
          var param = {"inflowType":"WISH"};
    
          //로그인시
          if (isLogin) {
            //위시리스트 삭제
            if ($this.hasClass("is-active")) {
              wishList.removeWish($this,modelId,storeId);
    
            } else {
              //위시리스트 추가
              //api 회원 동의여부 조회
              infoAgree.infoAgreeSelect(function(resultData){
    
                if(resultData ==null){
                  infoAgree.agreeConfirm(isLogin,param,function(){
                    // 위시리스트 추가
                    wishList.addWish($this,modelId,storeId);
                  }, true);
                }else if(resultData !==null && resultData.agreeYn === "N"){
                  var agreeDate = resultData.agreeDate;
                  var expires = infoAgree.convertDate(agreeDate);
                  var diff = vcui.date.diff(expires, new Date());
    
                  if(parseInt(diff.days) > 0){
                    infoAgree.agreeConfirm(isLogin,param,function(){
                      // 위시리스트 추가
                      wishList.addWish($this,modelId,storeId);
                    },true);
    
                  }else{
                    // 위시리스트 추가
                    wishList.addWish($this,modelId,storeId);
                  }
    
                }else {
                  // 위시리스트 추가
                  wishList.addWish($this,modelId,storeId);
                }
              }, isLogin);
            }
          }else{
    
            //비로그인시
            if(infoAgree.isStorageCheck()){
              //로그인
              doc.find(".wishlist-box > input, .btn-wishlist").each(function () {
                var $this = $(this);
                if ($this.hasClass("btn-wishlist")) {
                  $this.removeClass("is-active");
                } else {
                  $this.prop("checked", false);
                }
              });
              lgkorUI.confirm("로그인 후 이용가능 합니다.<br>로그인하시겠어요? ", {
                title: "",
                cancelBtnName: "아니오",
                okBtnName: "네",
                cancel: function () {
    
                },
                ok: function () {
                  location.href = vcui.uri.updateQueryParam(
                      loginUrl,
                      "state",
                      encodeURIComponent(moveUrl)
                  );
                },
              }, e.currentTarget); // BTOCSITE-77491 웹접근성
            }else{
              //최초진입 또는 동의 취소한지 1일이 지난 경우 레이어 노출
              infoAgree.gatepageAgreeConfirm(isLogin,param,function(){
                // 위시리스트 추가
                wishList.addWish($this);
              });
            }
          }
      });
      // BTOCSITE-23820 end

      // 혜택 아코디언
      CbtnInfo.on("click", function () {
        var $this = $(this);
        Cinfo.stop();
        if (Cinfo.is(":visible")) {
          Cinfo.slideUp(200);
          $this.addClass("btn-close");
          $this.find(".blind").text("펼치기");
        } else {
          Cinfo.slideDown(200);
          $this.removeClass("btn-close");
          $this.find(".blind").text("닫기");
        }
      });

      var param = {
        storeId: storeId,
        modelId: modelId,
        modelUrlPath: modelUrlPath,
      };
      //스펙
      lgkorUI.requestAjaxDataPost(specUrl, param, function (result) {
        var data = result.data[0].keyFeatures.splice(0, 3);
        var keyInfo = doc.find(".key-info");
        if (data.length === 0) {
          keyInfo.hide();
          keyInfo.addClass("no-data");
        } else {
          data.forEach(function (el, idx) {
            data[idx].SPEC_VALUE_NAME = el.SPEC_VALUE_NAME.replace(
              /&lt;/gi,
              "<"
            ).replace(/&gt;/gi, ">");
          });
          keyInfo
            .find("ul")
            .empty()
            .prepend(
              vcui
                .template(template.gateSpec, data)
                .replace(/&lt;/gi, "<")
                .replace(/&gt;/gi, ">")
            );
        }
      });
      //컨텐츠
      lgkorUI.requestAjaxDataPost(ajaxUrl, param, function (result) {
        var pdInfoWrap = doc.find(".pd-info-wrap");
        var cPoint = doc.find(".c-point");
        var pdAddinfo = doc.find(".pd-addinfo");
        var score = pdAddinfo.find(".scope");
        var review = pdAddinfo.find("li:eq(1) .num");
        var recommendPdList = doc.find(".recommend-pd-list");
        var recommendPd = recommendPdList.closest(".recommend-pd");
        var o4osmCompare = doc.find(".o4osm-compare");
        var productInfo = result.data[0];
        pdInfoWrap.children(".pd-util, .pd-list").each(function () {
          var $this = $(this);
          // $this.remove();
        });

        //BTOCSITE-20908 온라인 구매하기 버튼 추가 start
        var onlinePurchase = pdInfoWrap.find(".online-purchase");

        // BTOCSITE-31895 - 모델 판매상태 신규값 추가에 따른 구매하기 버튼 조건 변경
        if (productInfo.modelStatusCode === "ACTIVE" && productInfo.obsOriginalPrice > 0) {
          onlinePurchase.attr("href", productInfo.modelUrlPath);

          var onlineDate = new Date();
          var onTime = {
            hh: 20,
            mm: 30,
          };
          var offTime = {
            hh: 10,
            mm: 0,
          };
          if (onlineDate.getDay() === 0) {
            //일요일
            offTime.mm = 30;
          }
          var toTime = onlineDate.getTime();
          onlineDate.setHours(onTime.hh);
          onlineDate.setMinutes(onTime.mm);
          onlineDate.setSeconds(0);
          var startTime = onlineDate.getTime();
          onlineDate.setHours(offTime.hh);
          onlineDate.setMinutes(offTime.mm);
          onlineDate.setSeconds(0);
          var endTime = onlineDate.getTime();
          if (toTime < startTime && toTime >= endTime) {
            onlinePurchase.hide();
          }
        } else {
          onlinePurchase.hide();
        }
        //BTOCSITE-20908 온라인 구매하기 버튼 추가 end

        // 리뷰/상세정보 팝업
        //lgkorUI.cremaLogin();
        var reviewParam = {
            pdpPageType : "STORE"
        };
        $.ajax({
            url: "/mkt/review/"+productInfo.modelId+"/pdpReviewList",
            type: "GET",
            data: reviewParam,
            contentType : 'application/x-www-form-urlencoded; charset=UTF-8;',
            async: false,
            success: function(data) {
                $(".o4o-pd-area").empty();
                doc
                  .find("#popup-pd-list .o4o-pd-area")
                  .html(data);
            },
            error: function(e) {
                void 0;
            }
        });
//        $(".o4o-pd-area").empty();
//        doc
//          .find("#popup-pd-list .o4o-pd-area")
//          .append(
//            '<style>.crema-product-reviews > iframe { max-width: 100% !important; }</style><div class="crema-product-reviews" data-widget-id="' +
//              "26" +
//              '" data-product-code="' +
//              productInfo.modelName +
//              '"></div>'
//          );
        var viewPopArea = doc.find("#popup-pd-view .o4o-pd-area");
        doc
          .find("#popup-pd-view .o4o-pd-area")
          .append(
            '<iframe src="" width="100%" allowtransparency="true" frameborder="0" ></iframe>'
          );
        $("#popup-pd-view").on("modalshow", function (e, data) {
          var $this = $(e.currentTarget);
          $this.find(".tabs-wrap").css("width", "100%");
          $this.find(".pop-conts").css("overflowY", "hidden");
        });

        //BTOCSITE-86719 START
        var pdList = pdInfoWrap.find(".pd-list-case .pd-list");
        var pdPrice = pdList.find(".pd-txt .price");
        var pdPriceNoData = pdList.find(".pd-txt .price-noData");
        var pdName = pdList.find(".pd-tit .pd-name");
        var pdSku = pdList.find(".pd-tit .pd-sku");

        if (Array.isArray(productInfo.rentalInfo) && productInfo.rentalInfo.length > 0) {
          var priceTab = pdInfoWrap.find(".case-tabs-type");
          var rentalPriceTab = priceTab.find("#rentalPriceTab");
          var years1TotAmt = "";
          var maxYears1TotAmt = "";

          productInfo.rentalInfo.forEach(function (item) {
            if (item.representChargeFlag === "Y") {
              years1TotAmt = item.years1TotAmt;
            }
          });
          if (Array.isArray(productInfo.rentalAssociatedCardList) && productInfo.rentalAssociatedCardList.length > 0) {
            var maxSalePrice = 0;

            productInfo.rentalAssociatedCardList.forEach(function (item) {
              if (item.maxSalePrice > maxSalePrice) {
                maxSalePrice = item.maxSalePrice;
              }
            });
            maxYears1TotAmt = Math.max(0, years1TotAmt - maxSalePrice);
          }
          var rentalPriceTemplate = $('#rentalPrice-template').html();
          if (rentalPriceTemplate) {
              rentalPriceTemplate = rentalPriceTemplate.replace("#rentalPrice#", vcui.number.addComma(years1TotAmt));
              if (maxYears1TotAmt !== "" && maxYears1TotAmt !== null) {
                  rentalPriceTemplate = rentalPriceTemplate.replace("#rentalMaxPrice#", vcui.number.addComma(maxYears1TotAmt));
              }
              if (!rentalPriceTab.children().length) {
                rentalPriceTab.append(rentalPriceTemplate);
              }
          }
          priceTab.show();
        } else {
          pdPrice.show();
          pdPriceNoData.show();
        }
        //BTOCSITE-86719 END
        pdInfoWrap.data("productInfo", productInfo);
        setTimeout(function () {
          $(window).trigger("compareInit");
        }, 400);
        pdName.html(productInfo.modelDisplayName);
        pdSku.text(productInfo.modelName);
        doc.find(".pd-img > img").attr("src", productInfo.smallImageAddr);
        //캐시백 데이터 없을 때
        //BTOCSITE-86719 START
        if (productInfo.rewardAmt !== null && productInfo.rewardAmt > 0) {
          cPoint.html(
            vcui.number.addComma(productInfo.rewardAmt) + "<span>원</span>"
          );
        } else {
          cPoint.closest(".pd-cashback-tit").hide();
          CbtnInfo.addClass("alone-type");
        }
        //BTOCSITE-86719 END
        //별점
        score.text(productInfo.reviewsScore);
        pdAddinfo
          .find(".star-rating")
          .width((productInfo.reviewsScore / 5) * 100 + "%");
        if (productInfo.reviewsScore == null || productInfo.reviewsScore == 0) {
          pdAddinfo.find(".btn-detail-more").hide();
        }
        //[BTOCSITE-57367] 리뷰 내재화
        if(productInfo.reviewsCount > 9999){
          review.text("9,999+");
        }else{
          review.text(vcui.number.addComma(productInfo.reviewsCount));
        }
        if (productInfo.wishListFlag === "Y") {
          doc.find(".btn-wishlist").addClass("is-active");
        } else {
          doc.find(".btn-wishlist").removeClass("is-active");
        }
        //추천 제품
        pdInfoWrap
          .find(".btn-compare-etc")
          .attr("data-model-id", productInfo.modelId);
        //메모
        doc.find(".btn-memo").each(function () {
          var $this = $(this);
          var memoText = productInfo.content; //메모내용
          if (memoText != null && memoText != "") {
            $this.addClass("active");
          }
          $this.attr({
            "data-note-list-flag": productInfo.noteListFlag,
            "data-wish-list-id": productInfo.wishListId,
            "data-memo-save":
              "/mkt/api/bestshop/storemode/wishlist/pdpModifyNote",
            "data-memo-remove":
              "/mkt/api/bestshop/storemode/wishlist/pdpModifyNote",
            "data-memo-txt": memoText || "",
            "data-memo-date": productInfo.noteLastUpdateDate || "",
            "data-memo-id": productInfo.noteId || "",
          });
        });
        //메모
        recommendPd.hide();
        recommendPdList.empty();
        $.each(productInfo.howAboutProductList, function (idx, el) {
          el.price = vcui.number.addComma(el.price);
          el.obsOriginalPrice = vcui.number.addComma(el.obsOriginalPrice);
          //[BTOCSITE-57367] 리뷰 내재화
          if(el.reviewsCount > 9999){
            el.reviewsCount = "9,999+";
          }else{
            el.reviewsCount = vcui.number.addComma(el.reviewsCount);
          }
          el.rate = String(el.rate);
          recommendPdList.append(
            vcui
              .template(template.gateRecommendProduct, el)
              .replace(/&lt;/gi, "<")
              .replace(/&gt;/gi, ">")
          );
          recommendPdList.children("li").eq(idx).data("productInfo", el);
          recommendPd.show();
          compare.methodes.compareBtnStatus();
        });
        $(".pd-info").show();

        // 리뷰 팝업
        doc.find(".pd-addinfo .btn-detail-more").on("click", function (e) {
          e.preventDefault();
          doc.find("#popup-pd-list").vcModal("show");
        });
        //GA관련 팝업 닫을 때 GA 안나오게
        doc.on("modalhide", "#popup-pd-view", function (e) {
          var $this = $(e.currentTarget);
          $this.find("iframe").attr("src", "");
        });
        // 상세 팝업
        doc.find(".btn-pd-detail").on("click", function (e) {
          e.preventDefault();
          var iframe = doc.find("#popup-pd-view").find("iframe");
          doc.find("#popup-pd-view").vcModal("show");

          iframe.off("load").on("load", function () {
            var $this = $(this);
            var $iframe = $this.contents();
            $iframe.find(".contents-menu-list .tab-menu > a").each(function () {
              var $this = $(this);
              $this.attr(
                "data-contents",
                productInfo.modelDisplayName + "/" + productInfo.modelName
              );
            });
          });

          iframe.attr(
            "src",
            "https://" +
              window.LGEAPPHostName +
              doc.find(".btn-pd-detail").data("url") +
              "?dpType=overSpec" +
              "#overview"
          );
        });
        // 스펙 팝업
        doc.find(".key-info .btn-detail-more").on("click", function (e) {
          e.preventDefault();
          var iframe = doc.find("#popup-pd-view").find("iframe");
          doc.find("#popup-pd-view").vcModal("show");

          iframe.off("load").on("load", function () {
            var $this = $(this);
            var $iframe = $this.contents();
            $iframe.find(".contents-menu-list .tab-menu > a").each(function () {
              var $this = $(this);
              $this.attr(
                "data-contents",
                productInfo.modelDisplayName + "/" + productInfo.modelName
              );
            });
          });

          iframe.attr(
            "src",
            "https://" +
              window.LGEAPPHostName +
              doc.find(".btn-pd-detail").data("url") +
              "?dpType=overSpec" +
              "#pdp_spec"
          );
        });

        //usp
        var uspList = productInfo.uspList;
        var miniUsp = $(".mini-usp");
        if (uspList.length > 0) {
          miniUsp.show();
          miniUsp.closest(".usp-wrap").show();
          var swiperWrap = miniUsp.find(".slide-wrap");
          $(window).on("message", function (e) {
            miniUsp.children("iframe").height(e.originalEvent.data.contHeight);
            // miniUsp
            //   .children("iframe")
            //   .stop()
            //   .animate({ height: e.originalEvent.data.contHeight }, 220);
          });
          miniUsp.children("iframe").height("500px");
          miniUsp
            .children("iframe")
            .attr("src", decodeURIComponent(uspList[0].encurl));
        }
        //usp

        //리얼터치
        var vrInfo = productInfo.vrInfo;
        if (vrInfo.length > 0) {
          var realTouchPop = $("#popup-realtouch");
          $(document).find(".usp-wrap, .real-touch").show();
          vrInfo.forEach(function (el) {
            el.encurl = decodeURIComponent(el.encurl);
          });
          realTouchPop
            .find(".slide-track")
            .html(vcui.template(template.realTouch, vrInfo));
          if (vrInfo.length === 1) {
            realTouchPop.find(".realtouch-indi-wrap").hide();
          }

          $(window).on("resize.realtouch", function () {
            $("#popup-realtouch .pop-conts").css(
              "max-height",
              window.innerHeight - 100
            );
          });

          realTouchPop.on("modalshow", function (e) {
            var $this = $(e.currentTarget);
            var btnNext = $this.find(".r-btn-next");
            var btnPrev = $this.find(".r-btn-prev");
            var swiperWrap = $this.find(".ui_carousel_slider");
            var indi = $this.find(".indi-paging");
            var iframeLoadCount = 0;
            $("body").css("touchAction", "auto");
            swiperWrap.css("visibility", "hidden");
            swiperWrap.vcCarousel("update");
            indi.children(".num1").text(1);
            swiperWrap
              .find("iframe")
              .off("load")
              .on("load", function () {
                iframeLoadCount++;
                if (iframeLoadCount === vrInfo.length) {
                  swiperWrap.vcCarousel("reinit");
                  swiperWrap.css("visibility", "");
                }
                $(window).trigger("resize");
              });
            indi.children(".num2").text(swiperWrap.find("iframe").length);
            btnNext.off("click").on("click", function () {
              swiperWrap.vcCarousel("next");
              indi
                .children(".num1")
                .text(swiperWrap.vcCarousel("getCurrent") + 1);
            });
            btnPrev.off("click").on("click", function () {
              swiperWrap.vcCarousel("prev");
              indi
                .children(".num1")
                .text(swiperWrap.vcCarousel("getCurrent") + 1);
            });
          });
          realTouchPop.on("modalhide", function (e) {
            $("body").css("touchAction", "");
          });
        }
        //리얼터치

        // BTOCSITE-23820 start
        // 로그인 후 제3자동의 여부 레이어 노출을 위한 기능
        if(etc.getParameterByName("agree") === "Y"){
          infoAgree.returnUrl(function () {
            if (productInfo.wishListFlag === "N") {
              doc.find(".btn-wishlist").trigger("click");
            }
          });
        }
        // BTOCSITE-23820 end
      });
    },
    wishList: function () {
      var doc = $(document);
      var container = doc.find(".container");
      var ajaxUrl = container.data("ajaxUrl");
      var tabUrl = container.data("tabUrl");
      var wPdWrap = doc.find(".w-pd-wrap");
      var listWrap = wPdWrap.find("ul.pd-list");
      var tabArea = doc.find(".w-tabs");
      var noWishList = doc.find(".no-wishlist");
      var totalWishList = doc.find(".total-wishlist");
      var wishListPdDesc = doc.find(".wishlist-pd-desc");
      var count = 1;
      var headerSize = doc.find(".mobile-nav-wrap").height();
      var footerSize = 94;
      setTimeout(function () {
        $(window).trigger("compareInit");
      }, 400);
      //담긴 제품 영역 사이즈 조절
      noWishList.css(
        "minHeight",
        $(window).height() -
          headerSize -
          doc.find(".o4osm-bottom-wrap").height() -
          footerSize
      );

      //첫 진입 시 로그인 체크
      //롯데 본점 예외 처리
      var backUrl = location.href;
      if (backUrl.indexOf("ST00005604") !== -1) {
        backUrl += "&lotte=1";
      }
      etc.loginChk(
        undefined,
        function () {
          etc.historyBack();
        },
        backUrl
      );

      //탭 더보기 버튼 계산
      function tabMoreBtnStatus() {
        var tabItem = tabArea.find(".tab-item");
        var tabFirst = tabArea.find(".tab-item").first().next();
        var tabLast = tabArea.find(".tab-item").last();
        var btnWrap = doc.find(".w-tabs-wrap .w-btn-wrap");
        var extendBtn = btnWrap.find(".w-btn");
        if (tabItem.length > 0) {
          if (tabFirst.offset().top >= tabLast.offset().top) {
            btnWrap.hide();
          } else {
            btnWrap.show();
          }
        }
      }
      //footer Show
      function footerShow() {
        wishListPdDesc.show();
        doc
          .find(".o4o-store-sub")
          .css("paddingBottom", doc.find(".o4osm-bottom-wrap").height());
      }
      //탭 init
      function wishTabInit(param) {
        var params = param || undefined;
        tabArea.attr('roll','tablist');
        lgkorUI.requestAjaxDataPost(tabUrl, params, function (result) {
          if (
            result.data.listData === undefined ||
            result.data.listData === null
          ) {
            tabArea.closest(".w-tabs-wrap").remove();
            wishListInit();
          } else {
            result.data.listData.unshift({
              wishlistTypeCode: "",
              storeId: "",
              store: "전체",
            });

            var tabHtml = vcui.template(template.wishTab, result.data.listData);
            tabArea.empty().prepend(tabHtml);

            tabMoreBtnStatus();
            tabArea.find("input").eq(0).click();
          }
        });
      }

      //리스트 init
      function wishListInit(param) {
        var params = param || undefined;
        lgkorUI.requestAjaxDataPost(ajaxUrl, params, function (result) {
          var listHtml = "";
          var storeList = [];
          var list;
          var listLength = listWrap.children("li").length; // BTOCSITE-77491 웹접근성
          if (
            result.data.listData === undefined ||
            result.data.listData === "" ||
            result.data.listData === null
          ) {
            noWishList.show();
            totalWishList.hide();
            footerShow();
            return false;
          }
          if (count === 1) {
            listWrap.empty();
          }
          list = result.data.listData.slice((count - 1) * 10, count * 10);
          list.forEach(function (el) {
            el.price = vcui.number.addComma(el.price);
            el.pdLength = el.storeList.length;
            el.ga = JSON.stringify({
              model_name: el.title,
              model_id: el.id,
              model_gubun: el.modelGubun,
              price: el.price,
              brand: "LG",
              category:
                el.superCategoryName +
                "/" +
                el.categoryName +
                "/" +
                el.subCategoryName,
              ct_id: el.categoryId,
              model_super_category: el.superCategoryName,
              model_category: el.categoryName,
              model_sub_category: el.subCategoryName,
            });
            listHtml += vcui
              .template(template.wishListProduct, el)
              .replace(/&lt;/gi, "<")
              .replace(/&gt;/gi, ">");
          });

          listWrap.append(listHtml);
          noWishList.hide();
          totalWishList.show();
          footerShow();
          tabMoreBtnStatus();

          var totalH = totalWishList.height();
          if (
            totalH <
            $(window).height() -
              headerSize -
              doc.find(".o4osm-bottom-wrap").height()
          ) {
            totalWishList.css(
              "minHeight",
              $(window).height() -
                headerSize -
                doc.find(".o4osm-bottom-wrap").height() -
                footerSize
            );
          } else {
            totalWishList.css("minHeight", "");
          }

          listWrap.children("li").each(function (idx) {
            var $this = $(this);
            $this.data("productInfo", result.data.listData[idx]);
          });

          if (count === 1) {
            $(".w-tabs-wrap .w-btn-wrap > button")
              .addClass("btn-open")
              .removeClass("btn-close");
            //$(".w-pd-wrap .store-util:eq(0) > button").click();
          } else if(count > 1) { // BTOCSITE-77491 웹접근성
            listWrap.children('li').eq(listLength).find('a:first-child').focus();
          }
          //총 개수
          wPdWrap
            .find(".pd-util > .num > strong")
            .text("총 " + result.data.listData.length + "개");
          //더보기 버튼
          if (listWrap.children("li").length === result.data.listData.length) {
            doc.find(".btn-more").hide();
          } else {
            doc.find(".btn-more").show();
          }
          compare.methodes.compareBtnStatus();
        });
      }
      setTimeout(function () {
        compare.methodes.compareBtnStatus();
      }, 300);
      // wishListInit(); 중복실행 방지
      wishTabInit();
      //맵 이동
      doc.on("click", ".btn-store-map", function (e) {
        var $this = $(e.currentTarget);
        var cateName = $this.data("categoryName");
        lgkorUI.setStorage("storeMap", cateName);
      });
      //더보기
      doc.on("click", ".btn-more", function () {
        var param = {
          wishType: "",
          storeId: "",
        };
        doc.find(".w-tabs input:checked").each(function (idx) {
          var $this = $(this);
          var wishType = $this.data("wishListTypeCode");
          var storeId = $this.data("storeId");
          if (idx !== 0) {
            if (param.wishType.indexOf(wishType) < 0) param.wishType += ",";
            param.storeId += ",";
          }
          if (param.wishType.indexOf(wishType) < 0) param.wishType += wishType;
          param.storeId += storeId;
        });
        count++;
        wishListInit(param);
      });
      //접어 보기
      doc.on("click", ".w-pd-wrap .store-util > button", function () {
        var $this = $(this);
        var conArea = $this.closest(".store-util").next(".store-list-wrap");
        var count = 0;
        var btn = wPdWrap.find(".pd-util > button");
        var allBtnTxt = btn.children("span");
        $this.toggleClass("btn-open btn-close");
        conArea.toggle();

        if ($this.hasClass("btn-open")) {
          // 접어보기
          $this.children("span").text("펼쳐 보기");
        } else {
          // 펼쳐보기
          $this.children("span").text("접어 보기");
        }

        $this
          .closest(".pd-list")
          .find(".store-util > button")
          .each(function () {
            var $this = $(this);
            if ($this.hasClass("btn-open")) {
              count++;
            }
          });
        if (count > 0) {
          btn
            .addClass("btn-open")
            .removeClass("btn-close")
            .children(".blind")
            .text("열기");
          allBtnTxt.text("상세보기");
        } else {
          btn
            .addClass("btn-close")
            .removeClass("btn-open")
            .children(".blind")
            .text("접기");
          allBtnTxt.text("간략보기");
        }
      });
      //탭 영역 토글
      doc.on("click", ".w-tabs-wrap .w-btn-wrap > button", function () {
        var $this = $(this);
        var txt = $this.children(".blind");
        var tabWrap = $this.closest(".w-tabs-wrap").children(".w-tabs");
        if ($this.hasClass("w-btn-open")) {
          tabWrap.css("height", "auto");
          txt.text("펼쳐짐");
        } else {
          tabWrap.css("height", "");
          txt.text("접힘");
        }
        $this.toggleClass("w-btn-open w-btn-close");
      });
      //전체 지점 버튼
      wPdWrap.find(".pd-util > button").on("click", function () {
        var $this = $(this);
        var txt = $this.children(".blind");
        $this.toggleClass("btn-open btn-close");
        if ($this.hasClass("btn-open")) {
          // 접어보기
          $this.children("span").text("상세보기");
        } else {
          // 펼쳐보기
          $this.children("span").text("간략보기");
        }

        wPdWrap.find(".store-util > button").each(function () {
          var listBtn = $(this);
          var allBtnTxt = listBtn.children("span");
          var conArea = listBtn.closest(".store-util").next(".store-list-wrap");
          if ($this.hasClass("btn-open")) {
            listBtn.addClass("btn-open").removeClass("btn-close");
            conArea.hide();
            txt.text("열기");
            allBtnTxt.text("펼쳐 보기");
          } else {
            listBtn.addClass("btn-close").removeClass("btn-open");
            conArea.show();
            txt.text("접기");
            allBtnTxt.text("접어 보기");
          }
        });
      });
      //장바구니 담기
      doc.on("click", ".btn-cart", function (e) {
        var $this = $(this);
        var ajaxUrl = container.data("cartUrl");
        var typeFlag = $this.data("typeFlag");
        var param = {
          id: $this.data("id"),
          sku: $this.data("sku"),
          rtSeq: $this.data("rtSeq") || "",
          typeFlag: "",
        };
        // BTOCSITE-49721 UP가전 2.0+가전구독 통합 장바구니 기능 구현
        var modelList = [];
        var modelMap = {
        		"modelId": $this.data("id"),
              	"sku": $this.data("sku"),
              	"rtModelSeq": $this.data("rtSeq") || "",
              	"bizType": $this.data("bizType")
        };
        modelList.push(modelMap);
        param.modelList = JSON.stringify(modelList);

        if (typeFlag === "C") {
          //렌탈상품
          param.typeFlag = "C";
          lgkorUI.requestCart(ajaxUrl, param, true);
        } else {
          var requireCare = $this.data("requireCare");
          if (lgkorUI.stringToBool(requireCare)) {
            //케어십 필수 제품
            e.preventDefault();
            param.typeFlag = "C";
            //케어십 안내문
            $("#popup-o4osm-guide6").vcModal("show").on("modalhide", function () { // BTOCSITE-77491 웹접근성
              setTimeout(function () {
                $this.focus();
              }, 300);
            });
          } else {
            //일반구매 제품
            param.typeFlag = "P";
            lgkorUI.requestCart(ajaxUrl, param, true);
          }
        }
      });

      //탭 변경
      tabArea.on("change", "input[type=checkbox]", function (e) {
        count = 1;
        var $this = $(e.currentTarget);
        var span = $this.closest("span");
        var tabWrap = $this.closest(".w-tabs");
        var labelTxt = $this.next("label").text();
        var label = $this.next("label");
        var param = {
          wishType: "",
          storeId: "",
        };

        if ($this.prop("checked")) {
          $this.next("label").append('<span class="blind">선택됨</span>');
        } else {
          $this.next("label").find('span.blind').remove();
        }

        if (labelTxt === "전체" && $this.prop("checked")) {
          $this.prop("disabled", true);
          span.siblings("span").find("input").prop("checked", false);
        } else {
          var all = span.prevAll().last().find("input");
          all.prop("checked", false);
          all.prop("disabled", "");
        }

        if (
          tabWrap.find("input[type=checkbox]:checked").length === 0 ||
          tabWrap.find("input[type=checkbox]").length - 1 ===
            tabWrap.find("input[type=checkbox]:checked").length
        ) {
          tabWrap.find(".tab-item input").prop("checked", false);
          tabWrap
            .find(".tab-item")
            .eq(0)
            .children("input")
            .prop("checked", true);
          tabWrap.find(".tab-item label").find('span.blind').remove();
        }

        $this
          .closest(".w-tabs")
          .find("input:checked")
          .each(function (idx) {
            var $this = $(this);
            var wishType = $this.data("wishListTypeCode");
            var storeId = $this.data("storeId");
            if (idx !== 0) {
              if (param.wishType.indexOf(wishType) < 0) param.wishType += ",";
              param.storeId += ",";
            }
            if (param.wishType.indexOf(wishType) < 0)
              param.wishType += wishType;
            param.storeId += storeId;
          });
        count = 1;
        wishListInit(param);
      });
      //매장 삭제
      $("#popup-store-del").each(function () {
        var $this = $(this);
        var removeBtn = $this.find(".btn.mix");
        var ajaxUrl = container.data("removeUrl");
        removeBtn.off("click").on("click", function () {
          var opener = $this.data("ui_modal").getOpener();
          var data = opener.data();
          var param = {
            id: data.id,
            wishType: data.wishListTypeCode,
            storeId: data.storeId,
            type: "remove",
          };

          lgkorUI.requestAjaxDataPost(ajaxUrl, param, function (result) {
            var success = lgkorUI.stringToBool(result.success);
            $this.vcModal("close");
            if (success) {
              var _this = $this.vcModal("getOpener");
              var wrap = _this.closest(".store-wrap");
              var length = wrap.find(".store-list > li").length - 1;
              wrap.find(">.store-util .num").text(length);
              _this.closest(".store-list-item").remove();
              if (length === 0) {
                wrap.closest("li").remove();
              }
              wishTabInit();
            }
          });
        });
      });

      //BTOCSITE-23820 start
      infoAgree.wishAgreeTemplateInit();
      //BTOCSITE-23820 end
    },
    location: function () {
      var doc = $(document);
      var ajaxUrl = doc.find(".container").data("ajaxUrl");
      var tabWrap = doc.find(".tabs-wrap.ui_tab").parent();
      var mapArea = doc.find(".map-inner");
      var popMap = doc.find("#popup-map");
      //베스트샵 지점별 페이지 수정 start
      if (lgkorUI.getParameterByName("referrer").length > 0) {
        doc.find(".o4osm-bottom-wrap").hide();
      }
      //베스트샵 지점별 페이지 수정 end
      doc.find(".tabs-wrap.ui_tab").remove();
      mapArea.find(".img img").attr("src", "");
      lgkorUI.requestAjaxDataPost(ajaxUrl, {}, function (result) {
        var floor = [];
        var old = 0;
        var count = -1;

        function mapDataInit(data) {
          var titArea = doc.find(".tabs-con-tit");
          var titName = titArea.children(".tit-name");
          var titEtc = titArea.children(".tit-etc");
          titName.text(data.storeName);
          if (data.floorName.length > 0) {
            titEtc.html(
              "<em>" + data.floorName + "</em>_" + data.zoneName + " Zone"
            );
          } else {
            titEtc.html(data.zoneName + " Zone");
          }
          mapArea
            .find(".img img")
            .off("load")
            .on("load", function () {
              doc.find(".store-map").show();
            })
            .attr("src", data.imgUrl);
          popMap.find(".img img").attr("src", data.imgUrl);
        }
        $("#popup-map").on("modalshow", function (e, data) {
          var $this = $(e.currentTarget);
          var imgWrap = $this.find(".img-wrap");
          var img = imgWrap.find("img");
          setTimeout(function () {
            if (imgWrap.find(".pinch-zoom-container").length === 0) {
              new PinchZoom(img[0], {
                rotate: true,
                animationDuration: 200,
              });
            }
            imgWrap.find(".pinch-zoom-container, .img img").css({
              height: imgWrap.width(),
              width: imgWrap.height(),
            });
          }, 100);
        });

        if (result.Floor.length < 2) {
          mapArea.children(".btn-widemap").hide();
          mapDataInit(result.Map[0]);
          // new PinchZoom(mapArea.find(".img img")[0], {
          //   animationDuration: 200,
          // });
          return false;
        }
        result.Map.forEach(function (el, idx) {
          var data = el;
          if (old !== data.floorCode) {
            count++;
            floor.push([]);
          }
          old = data.floorCode;
          data.floorName = data.floorCode.slice(0, 1) + "F";
          floor[count].push(data);
        });

        tabWrap.append(vcui.template(template.mapFloorTab, result));

        if (result.Floor.length < 2) {
          var imgUrl = floor[0][0].imgUrl;
          mapArea
            .find(".img img")
            .off("load")
            .on("load", function () {
              doc.find(".store-map").show();
            })
            .attr("src", imgUrl);
          popMap.find(".img img").attr("src", imgUrl);
          return false;
        } else {
          floor.forEach(function (el) {
            tabWrap.append(vcui.template(template.mapFloorCont, el));
          });
        }

        tabWrap.children(".ui_tab").each(function (idx) {
          var $this = $(this);
          $this.vcTab();
          $this.on("tabchange", function (e, data) {
            var $this = data.button;
            if ($this.closest(".tabs-floor-pd").length === 0) {
              $this = data.content.find(".on a");
            }
            var imgArea = $this.find("img");
            var imgUrl = $this.data("map");
            var storeName = $this.data("storeName");
            var floorName = $this.data("floorName");
            var zoneIcon = $this.data("zoneIcon");
            var zoneName = $this.data("zoneName");

            imgArea
              .closest("li")
              .siblings("li")
              .find("img")
              .each(function () {
                var $this = $(this);
                $this.attr("src", $this.attr("src").replace("_on", "_off"));
              });
            imgArea.attr("src", imgArea.attr("src").replace("_off", "_on"));
            mapDataInit({
              storeName: storeName,
              floorName: floorName,
              zoneName: zoneName,
              imgUrl: imgUrl,
            });
          });
          if (idx === 1) {
            $this.vcTab("select", 0);
          }
        });

        //맵 이동
        if (lgkorUI.getStorage("storeMap").length !== undefined) {
          var productName = lgkorUI.getStorage("storeMap");
          result.Map.forEach(function (el) {
            if (el.zoneName === productName) {
              var floorTarget = $("span:contains(" + el.floorName + ")");
              var idx = floorTarget.closest("li").index();
              floorTarget.closest(".ui_tab").vcTab("select", idx);
              $("#tab1_" + el.floorName)
                .find("li")
                .each(function () {
                  var $this = $(this);
                  if ($this.children("a").data("zoneName") === productName) {
                    var idx = $this.index();
                    $this.closest(".ui_tab").vcTab("select", idx);
                  }
                });
            }
          });
        }
      });
    },
    event: function () {
      var doc = $(document);
      var ajaxUrl = doc.find(".container").data("ajaxUrl");
      var moreBtn = doc.find(".btn-more");
      var moreBtnWrap = moreBtn.closest(".btn-wrap");
      var listWrap = doc.find(".event-list-wrap .event-list");
      var viewLength = 0;
      listWrap.empty();
      function listInit() {
        lgkorUI.requestAjaxDataPost(ajaxUrl, {}, function (result) {
          var list = result.eventList;
          var html = "";
          var limitLength = 6;

          if (list === null) {
            doc.find(".no-event").show();
            return false;
          }

          if (list.length - viewLength > limitLength) {
            moreBtnWrap.show();
          } else {
            moreBtnWrap.hide();
          }
          for (var i = 0; i < limitLength; i++) {
            if (list[viewLength] !== undefined) {
              html += vcui.template(template.eventCont, list[viewLength]);
            }
            viewLength++;
          }
          listWrap.append(html);
          listWrap.children('li').eq(limitLength).find('a:first-child').focus(); // BTOCSITE-77491 웹접근성
          doc.find(".event-cont").not(".no-event").show();
        });
      }
      listInit();

      // 링크 클릭
      doc.on("click", ".event-list-item > a", function (e) {
        e.preventDefault();
        var $this = $(e.currentTarget);
        var url = $this.data("url");
        if (isApp()) {
          if (!url.match("https://")) {
            url = "https://" + window.LGEAPPHostName + url;
          }
          if (vcui.detect.isIOS) {
            var jsonString = JSON.stringify({
              url: url,
              command: "sendOutLink",
            });
            webkit.messageHandlers.callbackHandler.postMessage(jsonString);
          } else {
            android.openLinkOut(url);
          }
        } else {
          window.open(url);
        }
      });
      //더보기
      moreBtn.on("click", function (e) {
        e.preventDefault();
        listInit();
      });
    },
    popular: function () {
      var doc = $(document);
      var nowListUrl = doc.find(".container").data("ajaxVisitRecommend");
      var groupListUrl = doc.find(".container").data("ajaxGroupList");
      var RecommendUrl = doc.find(".container").data("ajaxRecommend");
      var o4oPopular = doc.find(".o4o-popular");

      //스와이프 버그로 visibility로 수정
      o4oPopular.css("visibility", "hidden");
      o4oPopular.show();
      //위시리스트 추가
      doc.on("click", ".wishlist-box > input", function (e) {
        e.preventDefault();
        var $this = $(e.currentTarget);
        var modelId = $this.data("modelId");
        var storeId =
          doc.find(".container").data("storeId") ||
          doc.find(".list-item.home > a").attr("href").split("storeId=")[1];
        var conts = $("input[data-model-id=" + modelId + "]");
        etc.loginChk(function () {
          if ($this.prop("checked")) {
            lgkorUI.requestAjaxDataPost(
              "/mkt/api/bestshop/storemode/wishlist/modifyWishlist",
              {
                type: "add",
                modelId: modelId,
                wishType: "10",
                storeId: storeId,
              },
              function (result) {
                $(window).trigger(
                  "toastshow",
                  "선택하신 제품이 위시리스트에 추가되었습니다."
                );
                $this.prop("checked", true);
                conts.prop("checked", true);
                $this.prop("title", "위시리스트 선택됨");
              }
            );
          } else {
            lgkorUI.requestAjaxDataPost(
              "/mkt/api/bestshop/storemode/wishlist/modifyWishlist",
              {
                type: "remove",
                modelId: modelId,
                wishType: "10",
                storeId: storeId,
              },
              function (result) {
                $(window).trigger(
                  "toastshow",
                  "선택하신 제품이 위시리스트에서 삭제되었습니다."
                );
                $this.prop("checked", false);
                conts.prop("checked", false);
                $this.prop("title", "");
              }
            );
          }
        }, undefined, undefined, $this); // BTOCSITE-77491 웹접근성
      });

      function popularProduct(ajaxUrl, target, param, tabIdx) {
        var params = param || undefined;
        lgkorUI.requestAjaxDataPost(ajaxUrl, params, function (result) {
          var tabHtml = "";
          var tabWrap = target.find(".now-tabs");

          //혼수 이사
          if (target.hasClass("dep02-con")) {
            var list;
            if (target.index() === 3) {
              list = result.marryTab;
            } else {
              list = result.moveTab;
            }
            if (list === undefined || list === "") {
              target.hide();
              return false;
            }

            var tabArray = [];
            if (!target.hasClass("tabInit")) {
              tabWrap.empty();
              list.forEach(function (el, idx) {
                tabArray.push({
                  gnbId: "BEST " + (idx + 1),
                  categoryName: "BEST " + (idx + 1),
                  categoryId: "",
                  tabIdx: tabIdx,
                });
              });
              if (tabArray.length > 1) {
                tabWrap.prepend(vcui.template(template.popularTab, tabArray));
                target.addClass("tabInit");
                tabWrap.find("input").eq(0).prop("checked", true);
              }
            }

            var onTab = target
              .find(".now-tabs")
              .find("input[type=radio]:checked");

            var tabIndex = onTab.closest(".tab-item").index() || 0;
            if (tabIndex < 0) tabIndex = 0;

            // var forCount = Math.ceil(list[tabIndex].length / 3);
            var contHtml = "";
            var contWrap = target.find(".now-pd-list");
            var moreBtn = target.find(".btn-more");

            list[tabIndex].forEach(function (el, idx) {
              el.tabIdx = tabIdx;
              el.idx = idx;
              contHtml += vcui
                .template(template.popularCont2, el)
                .replace(/&lt;/gi, "<")
                .replace(/&gt;/gi, ">");
            });
            if (list[tabIndex].length === 3) {
              moreBtn.hide();
            } else {
              moreBtn.show();
            }
            moreBtn.children("span").text("더보기");
            //더보기
            moreBtn.off("click.more").on("click.more", function (e) {
              e.preventDefault();
              var $this = $(this);
              var btnTxt = $this.children("span");
              var cont = target.find(".now-pd-list>li");
              var hideFirst = cont.filter(":hidden").first();
              var hideFirstIdx = hideFirst.index();
              if (btnTxt.text() === "닫기") {
                cont.eq(2).nextAll().hide();
                btnTxt.text("더보기");
              } else {
                hideFirst.show();
                hideFirst.nextUntil(cont.eq(hideFirstIdx + 6)).show();
                if (cont.filter(":hidden").length === 0) {
                  btnTxt.text("닫기");
                }
              }
              cont.eq(hideFirstIdx).find('a:first-child').focus(); // BTOCSITE-77491 웹접근성
            });
            contWrap.empty();
            contWrap.prepend(contHtml);
          } else {
            //매장
            var categoryList = result.categoryList;
            // 데이터가 없을 때
            if (
              categoryList === undefined ||
              categoryList === "" ||
              categoryList.length === 0
            ) {
              target.hide();
              target.prev(".now-tit01").hide();
              if (target.closest(".total-store").length) {
                target.closest(".total-store").hide();
              }

              if (tabIdx === 4) {
                setTimeout(function () {
                  o4oPopular.css("visibility", "");
                }, 300);
              }
              return false;
            }
            //탭 초기화
            if (!target.hasClass("tabInit")) {
              tabWrap.empty();
              categoryList.forEach(function (el) {
                el.tabIdx = tabIdx;
              });
              tabHtml = vcui.template(template.popularTab, categoryList);
              tabWrap.prepend(tabHtml);
              target.addClass("tabInit");
              tabWrap.find("input").eq(0).prop("checked", true);
            }
            // ALL 하나일 떄
            if (categoryList.length < 2) {
              tabWrap.closest(".now-tabs-wrap").hide();
            }
            var onTab = target
              .find(".now-tabs")
              .find("input[type=radio]:checked");
            var listWrap = target.find(".now-pd-list");
            var cateName = onTab.data("categoryName");
            var detailYn = onTab.data("detailViewYn");
            var tabCont;

            tabWrap.attr('roll','tablist');
            tabWrap.find('label span.blind').remove();
            onTab.next('label').append('<span class="blind">선택됨</span>');

            categoryList.forEach(function (el) {
              if (cateName === el.categoryName) {
                tabCont = el.productlist.splice(0, 3);
              }
            });
            tabCont.forEach(function (el, idx) {
              tabCont[idx].tabIdx = tabIdx;
              el.rate = el.rate.toFixed(1);
              //[BTOCSITE-57367] 리뷰 내재화
              if(el.reviewsCount > 9999){
                el.reviewsCount = "9,999+";
              }else{
                el.reviewsCount = vcui.number.addComma(el.reviewsCount);
              }
            });

            var detailBtn = target
              .find(".btn-detail-more")
              .closest(".btn-wrap");
            if (detailYn !== "Y") {
              detailBtn.hide();
            } else {
              detailBtn.show();
            }

            listWrap
              .empty()
              .prepend(
                vcui
                  .template(template.popularCont1, tabCont)
                  .replace(/&lt;/gi, "<")
                  .replace(/&gt;/gi, ">")
              );
            if (tabIdx === 4) {
              setTimeout(function () {
                o4oPopular.css("visibility", "");
              }, 300);
            }
          }
        });
      }

      var first = o4oPopular.find(".now-recommend:eq(0)>div:eq(0)");
      popularProduct(nowListUrl, first, {}, 1);
      first.on("change", "[type=radio]", function (e) {
        popularProduct(nowListUrl, first, {}, 1);
      });

      var mm = first.nextAll(".dep02-con");
      mm.each(function (idx) {
        var $this = $(this);
        popularProduct(groupListUrl, $this, {}, idx + 2);
        $this.on("change", "[type=radio]", function (e) {
          popularProduct(groupListUrl, $this, {}, idx + 2);
        });
      });

      var last = o4oPopular.find(".now-recommend:eq(1)>div");
      popularProduct(RecommendUrl, last, {}, 4);
      last.on("change", "[type=radio]", function (e) {
        popularProduct(RecommendUrl, last, {}, 4);
      });

      // 자세히보기
      doc.on("click", ".btn-detail-more", function (e) {
        var $this = $(e.currentTarget);
        var radio = $this
          .closest(".now-tabs-con")
          .prevAll(".now-tabs-wrap")
          .find("input[type=radio]:checked");
        var cateName = radio.next("label").text();
        lgkorUI.setStorage("storeDetail", cateName);
      });
    },
    popularSub: function () {
      var doc = $(document);
      var ajaxUrl = doc.find(".container").data("ajaxUrl");
      var tabWrap = doc.find(".now-tabs");
      var depth2Area = doc.find(".now-con-wrap");
      var depth2Tab = depth2Area.find(".tabs-wrap > .tabs");
      var uiTab = depth2Tab.closest(".ui_tab");
      var listWrap = doc.find(".now-pd-list");

      doc.on("click", ".wishlist-box > input", function (e) {
        e.preventDefault();
        var $this = $(e.currentTarget);
        var modelId = $this.data("modelId");
        var storeId = doc
          .find(".list-item.home > a")
          .attr("href")
          .split("storeId=")[1];
        etc.loginChk(function () {
          if ($this.prop("checked")) {
            lgkorUI.requestAjaxDataPost(
              "/mkt/api/bestshop/storemode/wishlist/modifyWishlist",
              {
                type: "add",
                modelId: modelId,
                wishType: "10",
                storeId: storeId,
              },
              function (result) {
                $(window).trigger(
                  "toastshow",
                  "선택하신 제품이 위시리스트에 추가되었습니다."
                );
                $this.prop("checked", true); // ture 버그 수정
                $this.prop("title", "위시리스트 선택됨");
              }
            );
          } else {
            lgkorUI.requestAjaxDataPost(
              "/mkt/api/bestshop/storemode/wishlist/modifyWishlist",
              {
                type: "remove",
                modelId: modelId,
                wishType: "10",
                storeId: storeId,
              },
              function (result) {
                $(window).trigger(
                  "toastshow",
                  "선택하신 제품이 위시리스트에서 삭제되었습니다."
                );
                $this.prop("checked", false);
                $this.prop("title", "");
              }
            );
          }
        });
      });

      function popularSubTab(param) {
        var params = param || undefined;
        lgkorUI.requestAjaxDataPost(ajaxUrl, params, function (result) {
          var categoryList = result.categoryList;
          var tab1 = [];
          var oldCategoryList = "";

          if (categoryList === undefined || categoryList === "") {
            return false;
          }
          if (!tabWrap.hasClass("tabInit")) {
            tabWrap.empty();
            categoryList.forEach(function (el, idx) {
              var data = el;
              if (oldCategoryList !== data.superCategoryId) {
                tab1.push({
                  categoryName: el.superCategoryName,
                  categoryId: el.categoryId || el.superCategoryId,
                  tabIdx: 1,
                });
              }
              oldCategoryList = data.superCategoryId;
            });
            tabWrap.prepend(vcui.template(template.popularTab, tab1));
            tabWrap.addClass("tabInit");
            if (lgkorUI.getStorage("storeDetail").length !== undefined) {
              var productName = lgkorUI.getStorage("storeDetail");
              var target = $("label:contains(" + productName + ")").prev(
                "input[type=radio]"
              );
              target.prop("checked", true);
              popularSubCont({ categoryId: target.data("categoryId") });
            } else {
              tabWrap.find("input[type=radio]").eq(0).prop("checked", true);
              popularSubCont({ categoryId: "ALL" });
            }
          }

          var onTab = tabWrap.find("input[type=radio]:checked");
          var cateName = onTab.data("categoryName");

          tabWrap.attr('roll','tablist');
          tabWrap.find('label span.blind').remove();
          onTab.next('label').append('<span class="blind">선택됨</span>');

          if (cateName !== "전체") {
            var tab2 = [];
            depth2Tab.empty();
            categoryList.forEach(function (el, idx) {
              if (el.categoryName) {
                if (el.categoryName.indexOf("/") > 0) {
                  var txtArr = el.categoryName.split("/") || el.categoryName;
                  el.categoryName = txtArr[0] + "/<br>" + txtArr[1];
                }
              }

              if (el.superCategoryName === cateName) {
                tab2.push(el);
              }
            });
            depth2Tab.prepend(
              vcui
                .template(template.popularSubTab, tab2)
                .replace(/&lt;/gi, "<")
                .replace(/&gt;/gi, ">")
            );
            depth2Tab.show();
            uiTab.vcTab("update");
            uiTab.vcTab("select", 0);
          } else {
            depth2Tab.hide();
          }
        });
      }

      function popularSubCont(param) {
        var params = param || undefined;
        lgkorUI.requestAjaxDataPost(ajaxUrl, params, function (result) {
          var productList = result.productList.splice(0, 10);

          productList.forEach(function (el, idx) {
            el.rate = el.rate.toFixed(1);
            //[BTOCSITE-57367] 리뷰 내재화
            if(el.reviewsCount > 9999){
              el.reviewsCount = "9,999+";
            }else{
              el.reviewsCount = vcui.number.addComma(el.reviewsCount);
            }
          });

          listWrap
            .empty()
            .prepend(
              vcui
                .template(template.popularCont1, productList)
                .replace(/&lt;/gi, "<")
                .replace(/&gt;/gi, ">")
            );
          $(".o4o-popular-sub").show();
        });
      }
      popularSubTab();
      tabWrap.on("change", "input[type=radio]", function (e) {
        e.preventDefault();
        var $this = $(e.currentTarget);
        var cateId = $this.data("categoryId");
        popularSubTab();
        if (cateId === "ALL") {
          popularSubCont({
            categoryId: "ALL",
          });
        }
      });

      depth2Tab.closest(".ui_tab").on("tabchange", function (e, data) {
        e.preventDefault();
        var $this = data.button;
        var cateId = $this.data("categoryId");
        popularSubCont({
          categoryId: cateId,
        });
      });
    },
    common: function () {
      var doc = $(document);
      var body = $("body");
      setTimeout(function () {
        doc.find(".toast-message").addClass("o4o-type")
        .attr({
          'role':'alert',
          'aria-live':'assertive',
          'aria-atomic':'true'
        });
      }, 25);
      doc.find(".mobile-nav-wrap > .btn-back").on("click", function (e) {
        e.preventDefault();
        etc.historyBack();
      });
      setTimeout(function () {
        $(".o4osm-toolbar").each(function () {
          var $this = $(this);
          $this.show();
        });
      }, 300);
      //위시리스트 클릭 시 로그인 체크
      doc.on(
        "click",
        ".list-item.wishlist a, .m-btn-type1 .btn-wishlist",
        function (e) {
          e.preventDefault();
          var url = $(e.currentTarget).attr("href");

          //롯데 본점 예외 처리
          if (url.indexOf("ST00005604") !== -1) {
            url += "&lotte=1";
          }

          etc.loginChk(
            function () {
              location.href = url;
            },
            undefined,
            url,
            e.currentTarget
          );
        }
      );
      //위시 리스트로 가기 로그인 체크
      doc.on("click", ".select-wishlist a", function (e) {
        e.preventDefault();
        var $this = $(e.currentTarget);
        var url = $this.data("url");

        //롯데 본점 예외 처리
        if (url.indexOf("ST00005604") !== -1) {
          url += "&lotte=1";
        }

        if (doc.find(".total-wishlist").length > 0) {
          compare.methodes.popClose($this.closest(".o4osm-compare"), 250);
        } else {
          etc.loginChk(
            function () {
              location.href = url;
            },
            undefined,
            url
          );
        }
      });

      // 앱 체크
      var openCont = "";
      body.prepend(vcui.template(template.qrCheckPop));
      body.prepend(vcui.template(template.qrNoData));
      body.prepend(vcui.template(template.notReady));
      doc.on(
        "click",
        ".go-to-qr a, .m-qr a,.list-item.qr a, .select-qr a, .btn-goto-qr",
        function (e) {
          openCont = $(e.currentTarget);
          if (!isApp()) {
            //웹
            $("#popup-o4osm-guide2").vcModal("show");
          } else {
            /*
            //앱
            if (
              $(".o4o-store-main").length > 0 ||
              openCont.hasClass("btn-goto-qr")
            ) {
              // 메인
              etc.qrCall();
            } else {
              // 그외
              if (openCont.closest(".select-qr").length > 0) {
                //비교하기
                etc.gateQrCall(openCont);
              } else {
                etc.gateQrCall();
              }
            }*/
            // BTOCSITE-23820 start
            if (openCont.closest(".select-qr").length > 0) {
              //앱 비교하기 QR 실행
              // etc.gateQrCall(openCont);
              infoAgree.qrAgreeInit(openCont);
            } else {
              // 앱 QR스캔 QR 실행
              // etc.gateQrCall();
              infoAgree.qrAgreeInit();
            }
            // BTOCSITE-23820 end
          }
        }
      );
      doc.on(
        "click",
        "#popup-o4osm-guide2 .o4osm-pop-conts > .btn-wrap > .btn:eq(0)",
        function (e) {
          e.preventDefault();
          var $this = $(e.currentTarget);
          if (!isApp()) {
            var homeUrl =
              "https://" + window.LGEAPPHostName + "/bestshop/storemode/main";
            if (
              doc.find(".o4o-store-main").length > 0 ||
              doc.find(".pocket-intro").length > 0
            ) {
              homeUrl = location.href;
            } else {
              homeUrl =
                "https://" +
                window.LGEAPPHostName +
                doc.find(".list-item.home > a").attr("href");
            }
            var url = vcui.uri.updateQueryParam(homeUrl, "move", "web");
            if (openCont.closest(".select-qr").length > 0) {
              if ($(".total-wishlist").length === 0) {
                //PDP
                url = location.href;
              } else {
                //WITH
                url = homeUrl;
              }
            }
            if ($(".o4o-store-main").length > 0) {
              url = vcui.uri.updateQueryParam(location.href, "move", "web");
            }
            goAppUrl(url.replaceAll("#", ""));
          }
        }
      );
      doc.on("modalhide", "#popup-o4osm-guide2", function () { // BTOCSITE-77491 웹접근성
        setTimeout(function () {
          doc.find(".m-qr a").focus();
        }, 300);
      });
      //BTOCSITE-21361 [ODR] [포켓베스트샵] QR 코드 인식 불가 팝업의 화면 이동 이슈 start
      doc.on("modalhide", "#popup-o4osm-guide5", function () {
        etc.gateQrCall();
      });
      //BTOCSITE-21361 [ODR] [포켓베스트샵] QR 코드 인식 불가 팝업의 화면 이동 이슈 end

      // BTOCSITE-23820 start
      $('.wrap').append(vcui.template(template.infoAgreeLayer));
      // BTOCSITE-23820 end

    },
    init: function () {
      var _this = page;
      var doc = $(document);
      var bottomOn = $({});
      var toolBar = $(".o4osm-toolbar-list");

      $(".pocket-intro").each(function () {
        _this.pocketIntro();
      });
      $(".msg-ing").each(function () {
        _this.noDataPage();
      });
      $(".o4o-store-main").each(function () {
        bottomOn = $(".list-item.home");
        _this.main();
        toolBar.children(".home").addClass("on");
      });
      $(".pd-info-wrap").each(function () {
        _this.gate();
      });
      $(".total-wishlist").each(function () {
        bottomOn = $(".list-item.wishlist");
        _this.wishList();
        toolBar.children(".wishlist").addClass("on");
      });
      $(".store-map").each(function () {
        _this.location();
      });
      $(".o4o-event").each(function () {
        _this.event();
        toolBar.children(".event").addClass("on");
      });
      $(".o4o-popular").each(function () {
        _this.popular();
        toolBar.children(".p-product").addClass("on");
      });
      $(".o4o-popular-sub").each(function () {
        _this.popularSub();
        toolBar.children(".p-product").addClass("on");
      });
      _this.common();
      bottomOn.addClass("on");
      compare.init();
      memo.init();
      // BTOCSITE-82760 전자가격표 QR 입력 시 랜딩되는 포켓베스트샵 페이지 케어서비스 영상 추가 개발 요청
      videoPop.init();

      // 링크 클릭
      doc.on("click", "#linkPopup > a", function (e) {
        e.preventDefault();
        var $this = $(e.currentTarget);
        var url = $this.data("url");
        if (isApp()) {
          if (!url.match("https://")) {
            url = "https://" + window.LGEAPPHostName + url;
          }
          if (vcui.detect.isIOS) {
            var jsonString = JSON.stringify({
              url: url,
              command: "sendOutLink",
            });
            webkit.messageHandlers.callbackHandler.postMessage(jsonString);
          } else {
            android.openLinkOut(url);
          }
        } else {
          window.open(url);
        }
      });
    },
  };

  //메모
  var memo = {
    el: {
      cont: "",
      textArea: "",
      infoArea: "",
      bottomArea: "",
      dateWrap: "",
      dateArea: "",
      btnWrap: "",
      saveBtn: "",
      removeBtn: "",
      txtLengthArea: "",
      maxLengthArea: "",
      maxLength: "",
    },
    val: {
      saveUrl: "",
      removeUrl: "",
      txt: "",
      date: "",
      id: "",
      wishListId: "",
    },
    bind: function ($this) {
      //텍스트 개수 갱신
      this.el.textArea.on("input", function (e) {
        var $this = $(this);
        var txtLength = $this.val().length;

        //max length
        if (txtLength > memo.el.maxLength) {
          var maxtext = $this[0].value.substr(0, memo.el.maxLength);
          $this[0].value = maxtext;
          txtLength = maxtext.length;
          $this.blur();
          // if (
          //   $("#laypop:visible .tit").text() !=
          //   "입력 가능한 글자수가 초과되었습니다."
          // ) {
          //   lgkorUI.alert("", {
          //     title: "입력 가능한 글자수가 초과되었습니다.",
          //   });
          // }
        }
        memo.el.txtLengthArea.text(txtLength);
        if (txtLength == 0) {
          memo.el.saveBtn.prop("disabled", true);
        } else {
          memo.el.saveBtn.prop("disabled", false);
        }
      });

      //팝업 오픈 시
      $this.on("modalshow", function (e, i) {
        memo.el.textArea.trigger("input");
        var opener = $(i.opener);
        var data = opener[0].dataset;
        memo.val.saveUrl = data.memoSave;
        memo.val.removeUrl = data.memoRemove;
        memo.val.txt = data.memoTxt;
        memo.val.date = data.memoDate;
        memo.val.id = data.memoId;
        memo.val.wishListId = data.wishListId;
        memo.el.txtLengthArea.text(0);
        memo.el.saveBtn.data("saveUrl", memo.val.saveUrl);
        memo.el.removeBtn.data("removeUrl", memo.val.removeUrl);
        //저장된 텍스트가 있을 때
        if (memo.val.txt.length > 0) {
          memo.el.textArea.val(memo.val.txt);
          memo.el.txtLengthArea.text(memo.val.txt.length);
          // dateWrap.html('< span>'+date+'< /span> 작성')
          memo.el.dateArea.text(memo.val.date);
          memo.el.dateWrap.show();
          memo.el.removeBtn.show();
        } else {
          //저장된 텍스트가 없을 때
          // dateWrap.empty();
          memo.el.textArea.val("");
          memo.el.dateWrap.hide();
          memo.el.removeBtn.hide();
        }
        //저장 버튼 클릭 시
        memo.el.saveBtn.off("click").on("click", function () {
          var text = memo.el.textArea.val();
          var param = {
            wishlistId: memo.val.wishListId,
            content: text,
          };

          //gate 페이지일 떄
          if ($(document).find(".pd-info-wrap").length > 0) {
            var gateWrap = opener.closest(".container");

            param = {
              modelId: gateWrap.data("modelId"),
              wishType: 10,
              storeId: gateWrap.data("storeId"),
              content: text,
            };

            if (data.noteListFlag !== "Y") {
              //등록
              param.type = "add";
              $(document).find(".btn-wishlist").addClass("is-active"); //위시 리스트 자동 등록
            } else {
              //갱신
              param.type = "update";
            }
            opener[0].dataset.noteListFlag = "Y";
          }
          //gate 페이지일 떄

          if (text.trim().length > 0) {
            lgkorUI.requestAjaxDataPost(
              memo.val.saveUrl,
              param,
              function (result) {
                if (result.data.success) {
                  opener[0].dataset.memoTxt = result.data.memoInfo.content;
                  opener[0].dataset.memoDate = result.data.memoInfo.date;
                  opener[0].dataset.memoId = result.data.memoInfo.noteId;
                  memo.el.dateWrap.show();
                  memo.el.dateArea.text(result.data.memoInfo.date);
                  memo.el.removeBtn.show();
                  $(opener[0]).addClass("active");
                  if ($(opener[0]).find(".blind").length === 0) {
                    $(opener[0]).prepend('<span class="blind">작성중</span>');
                  } else {
                    $(opener[0]).find(".blind").text("작성중");
                  }
                }

                if (
                  result.data.message !== "" &&
                  result.data.message !== null
                ) {
                  // lgkorUI.alert("", {
                  //   title: result.data.message,
                  // });
                  $(window).trigger("toastshow", result.data.message);
                  // [BTOCSITE-21445] odr 메모 팝업 텍스트 버튼으로 수정 start
                  // $("#popup-memo").vcModal("hide");
                  // [BTOCSITE-21445] odr 메모 팝업 텍스트 버튼으로 수정 end
                }
              },
              true
            );
          } else {
            // console.log("미입력 케이스");
          }
        });
      });

      //메모 삭제 버튼 클릭 시
      $(document).on("click", "#popup-meno-del .btn.mix", function (e, i) {
        var opener = $this.data("ui_modal").getOpener();
        var param = {
          wishlistId: memo.val.wishListId,
        };

        //gate 페이지일 떄
        if ($(document).find(".pd-info-wrap").length > 0) {
          var gateWrap = opener.closest(".container");
          param = {
            type: "remove",
            modelId: gateWrap.data("modelId"),
            wishType: 10,
            storeId: gateWrap.data("storeId"),
          };
          opener[0].dataset.noteListFlag = "N";
        }
        //gate 페이지일 떄

        lgkorUI.requestAjaxDataPost(
          memo.val.removeUrl,
          param,
          function (result) {
            if (result.data.success) {
              $("#popup-meno-del").vcModal("hide");
              $(window).trigger("toastshow", result.data.message);
              memo.el.dateWrap.hide();
              memo.el.removeBtn.hide();
              memo.el.textArea.val("");
              memo.el.txtLengthArea.text(0);
              opener[0].dataset.memoTxt = "";
              opener[0].dataset.memoDate = "";
              opener[0].dataset.memoId = "";

              if (result.data.message !== "" && result.data.message !== null) {
                // lgkorUI.alert("", {
                //   title: result.data.message,
                // });

                $("#popup-memo").vcModal("hide");
              }
              $(opener[0]).removeClass("active");
              if ($(opener[0]).find(".blind").length === 0) {
                $(opener[0]).prepend('<span class="blind">미작성중</span>');
              } else {
                $(opener[0]).find(".blind").text("미작성중");
              }
            }
          },
          true
        );
      });
    },
    setProperty: function ($this) {
      this.el.cont = $this.find(".o4osm-pop-conts");
      this.el.textArea = this.el.cont.find("textarea");
      this.el.infoArea = $this.find(".memo-txt-info");
      this.el.bottomArea = $this.find(".memo-bottom");
      this.el.dateWrap = this.el.bottomArea.children("p");
      this.el.dateArea = this.el.dateWrap.children("span");
      this.el.btnWrap = $this.find(".btn-wrap");
      this.el.saveBtn = this.el.btnWrap.children(".btn-save");
      this.el.removeBtn = this.el.btnWrap.children(".btn-del");
      this.el.txtLengthArea = this.el.infoArea.children("em");
      this.el.maxLengthArea = this.el.infoArea.children("span");
      this.el.maxLength = Number(this.el.maxLengthArea.text());
    },
    init: function () {
      var doc = $(document);
      $("#popup-memo").each(function () {
        var $this = $(this);
        var memoBtn = doc.find(".btn-memo");

        // BTOCSITE-64387 공통(7/7) memberinfo, logininfo api 개선
          var isLogin = digitalData.userInfo.isLogin;
          if (!isLogin) {
            memoBtn.attr("data-href", "");
            memoBtn.on("click", function (e) {
              etc.loginChk(undefined, undefined, undefined, e.currentTarget); // BTOCSITE-77491 웹접근성
            });
          } else {
            memo.setProperty($this);
            // memo.el.textArea.attr("maxlength", memo.el.maxLength);
            memo.bind($this);
          }
          
        });
    },
  };

  var compare = {
    el: {
      doc: $(document),
      o4osmCompare: "",
      toggleBtn: "",
      title: "",
      content: "",
    },
    val: {
      isInitChecked: false,
      willRemoveForCompare: false,
      compareIds: "",
      popSpeed: 200,
      storageName: "store_compare",
    },
    methodes: {
      popMarginOn: function (target) {
        // 팝업 영역 추가로 배경 영역 늘리기
        var container = $(document).find(".container");
        var pBottom =
          target.find(".o4osm-compare-tit").outerHeight(true) +
          parseInt(target.css("padding-top"));
        if ($(".pd-info-wrap").length > 0 || $(".total-wishlist").length > 0) {
          container.css("padding-bottom", pBottom);
        }
      },
      popMarginOff: function (target) {
        // 팝업 영역 삭제로 배경 영역 줄이기
        var container = $(document).find(".container");
        var pBottom =
          target.find(".o4osm-compare-tit").outerHeight(true) +
          parseInt(target.css("padding-top"));
        if ($(".pd-info-wrap").length > 0 || $(".total-wishlist").length > 0) {
          container.css("padding-bottom", "");
        }
      },
      popOpen: function (target, callback) {
        target.find(".o4osm-compare-contents").height("");
        //팝업 열기
        target.closest(".o4osm-bottom-wrap").addClass("add-compare");
        target.show();
        compare.methodes.popMarginOn(target);
        target
          .find(".o4osm-compare-contents")
          .stop()
          .slideDown(compare.val.popSpeed, "", callback || function () {});
        target.find(".o4osm-compare-tit").each(function () {
          var $this = $(this);
          $this
            .find(".btn-reset")
            .next("button")
            .removeClass("btn-open")
            .addClass("btn-close")
            .children(".blind").text("펼쳐짐");
        });
      },
      popClose: function (target, callback) {
        //팝업 닫기
        target.closest(".o4osm-bottom-wrap").addClass("add-compare");
        target
          .find(".o4osm-compare-contents")
          .stop()
          .slideUp(compare.val.popSpeed, "", callback || function () {});
        target.find(".o4osm-compare-tit").each(function () {
          var $this = $(this);
          $this
            .find(".btn-reset")
            .next("button")
            .removeClass("btn-close")
            .addClass("btn-open")
            .children(".blind").text("접힘");
        });
      },
      popHide: function (target, callback) {
        //팝업 히든
        compare.methodes.popMarginOff(target);
        compare.methodes.popClose(target, function () {
          target.hide();
          if (callback !== undefined && callback !== null) {
            callback();
          }
          target.closest(".o4osm-bottom-wrap").removeClass("add-compare");
        });
      },

      addToastAlert: function (mode) {
        var msg;
        if (mode === "excessive") {
          msg = "2개까지 비교가능합니다.";
        } else {
          return;
        }

        $(window).trigger("toastshow", msg);
      },
      compareBtnStatus: function () {
        var storageCompare = compare.methodes.getStorage(
          compare.val.storageName
        );
        $(".btn-compare, .btn-compare-etc").each(function () {
          var $this = $(this);
          $this.removeClass("on");
        });
        if (!vcui.isEmpty(storageCompare)) {
          for (var property in storageCompare) {
            storageCompare[property].data.forEach(function (el) {
              $("[data-model-id=" + el.id + "]").addClass("on");
            });
          }
        }
      },

      selectBoxTotalCount: function (target) {
        var uiSelectBox = target;
        if (uiSelectBox.length == undefined) {
          uiSelectBox = $(document).find(
            ".o4osm-compare-category .select-wrap .ui_selectbox"
          );
        }
        var options = uiSelectBox.find(".option");
        options.each(function () {
          var optionText = $(this).text();
          var replaceTarget = window.innerWidth > 767 ? "/2" : "/3";
          var replaceResult = window.innerWidth > 767 ? "/3" : "/2";
          var selectOpenElResult = optionText.replace(
            replaceTarget,
            replaceResult
          );

          $(this).text(selectOpenElResult);
        });

        uiSelectBox.vcSelectbox("update");
      },

      setCompares: function (id) {
        var doc = compare.el.doc;
        var categoryId =
          id ||
          Object.keys(compare.methodes.getStorage(compare.val.storageName))[0];

        var storageCompare = compare.methodes.getStorage(
          compare.val.storageName,
          categoryId
        );

        var isCompare = vcui.isEmpty(storageCompare);
        var compareCate = compare.methodes.getStorage(compare.val.storageName);
        var o4osmCompareCategory = doc.find(".o4osm-compare-category");
        var selectWrap = o4osmCompareCategory.find(".select-wrap");
        var uiSelectBox = selectWrap.find(".ui_selectbox");

        // 카테고리가 1개이상이면 selectbox 붙힌다
        if (Object.keys(compareCate).length > 1) {
          var selectData = {
            list: [],
          };
          Object.keys(compareCate).map(function (key) {
            var selected = "";
            if (categoryId === key) selected = "selected";

            selectData["list"].push({
              label: compareCate[key].data[0].categoryName,
              value: key,
              selected: selected,
              count: compareCate[key].data.length,
            });
          });

          if (uiSelectBox.find("option").length > 0) {
            uiSelectBox.find("option").remove();
            o4osmCompareCategory.hide();
          }
          uiSelectBox.prepend(
            vcui.template(compare.template.compareSelect, selectData)
          );
          o4osmCompareCategory.show();
          compare.methodes.selectBoxTotalCount(uiSelectBox);
          $(window)
            .off("resize.compare")
            .on("resize.compare", compare.methodes.selectBoxTotalCount);

          o4osmCompareCategory
            .find(".ui_selectbox")
            .vcSelectbox()
            .off("change")
            .on("change", function (e) {
              var categoryId = $(this).val();
              o4osmCompareCategory
                .closest(".o4osm-compare")
                .data("selectId", categoryId);
              compare.methodes.setCompares(categoryId);
              if (e.originalEvent === undefined) {
                compare.methodes.setCompareStatus(categoryId, true);
              } else {
                compare.methodes.setCompareStatus(categoryId);
              }
            });
        } else {
          o4osmCompareCategory.hide();
        }

        if (!isCompare) {
          if (!vcui.isEmpty(storageCompare)) {
            var ids = vcui.array
              .map(storageCompare["data"], function (item) {
                return item.id;
              })
              .join("|");

            if (compareIds !== ids) {
              var list;
              compareIds = ids;

              if (storageCompare["data"].length === 2) {
                doc.find(".pd-list-item").eq(1).show();
                doc.find(".pd-list-item").eq(2).hide();
              } else {
                doc.find(".pd-list-item").eq(1).hide();
                doc.find(".pd-list-item").eq(2).show();
              }
              storageCompare["data"].forEach(function (item, i) {
                var target = $(".pd-list .pd-con").eq(i);
                //액티브 추가
                target
                  .closest(".pd-list-item")
                  .addClass("is-active")
                  .siblings(".pd-list-item")
                  .removeClass("is-active");
                target.html(
                  vcui
                    .template(compare.template.compareCont, item)
                    .replace(/&lt;/gi, "<")
                    .replace(/&gt;/gi, ">")
                );
                target.find(".pd").each(function () {
                  $(this).data("pdInfoWrap", item);
                });
                compare.methodes.updateCompareButton();
              });
            }
          }
        }

        var leng = isCompare ? "0" : storageCompare.data.length;
        var count = doc.find(".o4osm-compare .c-num");
        count.html("<em><span class='blind'>현재 등록 개수</span>" + leng + "</em>/<span class='blind'>총 등록 개수</span>2");
        // if (Object.keys(compareCate).length > 1) {
        //   count.hide();
        // } else {
        //   count.show();
        // }
      },

      setCompareStatus: function (id, load) {
        var doc = compare.el.doc;
        var o4osmCompare = doc.find(".o4osm-compare");
        var $uiSelectbox = o4osmCompare.find(".ui_selectbox");
        var getCompareStorageKeys = Object.keys(
          compare.methodes.getStorage(compare.val.storageName)
        );
        var categoryId =
          id ||
          Object.keys(compare.methodes.getStorage(compare.val.storageName))[0];

        var storageCompare = compare.methodes.getStorage(
          compare.val.storageName,
          categoryId
        );
        var isCompare = vcui.isEmpty(storageCompare);

        var leng = isCompare ? 0 : storageCompare.data.length;
        if (leng) {
          var limit = 2;
          var isOpen = compare.el.toggleBtn.hasClass("btn-close");
          if (!isOpen) {
            if (load) {
              compare.methodes.popClose(o4osmCompare);
              return false;
            } else {
              compare.methodes.popOpen(o4osmCompare);
              o4osmCompare.prop('tabindex', 0);
              o4osmCompare.focus();
            }
          }
          compare.val.isInitChecked = true;
        } else {
          var removeOption = $uiSelectbox
            .find("option")
            .filter("[value=" + categoryId + "]");

          if (removeOption.length > 0) removeOption.remove();
          if ($uiSelectbox.find("option").length === 1) {
            $uiSelectbox.closest(".o4osm-compare-category").hide();
          }

          var removeForCompareCheck = function () {
            if (compare.val.isInitChecked) {
              compare.val.isInitChecked = false;
              if (!compare.val.willRemoveForCompare) {
                if (getCompareStorageKeys.length === 0) {
                  compare.methodes.addToastAlert();
                }
              } else {
                compare.val.willRemoveForCompare = false;
              }
            }
          };

          if (getCompareStorageKeys.length === 0) {
            compare.methodes.popHide(o4osmCompare);
          } else {
            compare.methodes.setCompares(
              Object.keys(
                compare.methodes.getStorage(compare.val.storageName)
              )[0]
            );
          }

          removeForCompareCheck();
        }
      },

      setClearCompare: function () {
        var doc = compare.el.doc;
        var o4osmCompare = doc.find(".o4osm-compare");
        var $uiSelectbox = o4osmCompare.find(".ui_selectbox");
        $uiSelectbox.children("option").remove();
        compare.methodes.removeStorage(compare.val.storageName);
      },

      updateCompareButton: function () {
        var doc = compare.el.doc;
        var o4osmCompare = doc.find(".o4osm-compare");
        var btnArea = o4osmCompare.find(".btn-area");
        var btn = btnArea.children("button");
        var listItem = o4osmCompare.find(".pd").closest(".pd-list-item");
        var count = 0;
        listItem.each(function () {
          var $this = $(this);
          if ($this.css("display") === "block") {
            count++;
          }
        });
        if (count > 1) {
          btn.addClass("btn-active");
        } else {
          btn.removeClass("btn-active");
        }
      },

      setCompareState: function ($this, data) {
        var doc = compare.el.doc;
        var _id = data.modelId || data.id;
        var categoryId =
          data.categoryId ||
          Object.keys(compare.methodes.getStorage(compare.val.storageName))[0];
        var o4osmCompare = doc.find(".o4osm-compare");
        if ($this.hasClass("on")) {
          var compareObj = {
            id: _id,
            productName: data.modelDisplayName || data.modelDisplayNamePlusSpec,
            productID: data.modelName,
            productImg:
              data.smallImageAddr ||
              data.imgUrl ||
              data.imageUrl ||
              data.smallImageUrl,
            productAlt: data.imageAltText,
            careType: categoryId,
            categoryName: data.categoryName,
            target: $this,
          };
          o4osmCompare.data("selectId", categoryId);
          compare.methodes.addCompareProd(categoryId, compareObj);
          compare.methodes.setCompares(categoryId);
        } else {
          // 마지막 상품일 때 팝업 닫기
          if (data.categoryId !== undefined) {
            var selectBoxArea = o4osmCompare.find(
              ".o4osm-compare-category .ui_selectbox"
            );
            if (selectBoxArea.css("display") === "block") {
              Object.keys(
                compare.methodes.getStorage(compare.val.storageName)
              ).map(function (key, idx) {
                if (key === categoryId) {
                  // 조작한 상품의 셀렉트박스로 이동
                  selectBoxArea.vcSelectbox("selectedIndex", idx);
                }
              });
            }

            if (
              compare.methodes.getStorage(
                compare.val.storageName,
                data.categoryId
              ).data.length === 1
            ) {
              if (compare.methodes.gateCateCheck("btnType")) {
                compare.methodes.popClose(o4osmCompare);
              } else {
                compare.methodes.popHide(o4osmCompare);
              }
              // compare.methodes.popClose(o4osmCompare);
            }
          }

          compare.methodes.removeCompareProd(categoryId, _id);
        }
      },
      addCompareProd: function (categoryId, data) {
        var self = lgkorUI;

        var compareLimit = self.getCompareLimit();

        var compareStorage = compare.methodes.getStorage(
          compare.val.storageName
        );
        if (compareStorage[categoryId] == undefined) {
          var categoryName = lgkorUI.getHiddenInputData().categoryName;
          compareStorage[categoryId] = {
            categoryName: categoryName,
            data: [data],
          };

          if (compareStorage[categoryId]["data"].length === 1) {
            // 비교하기 첫제품 추가시 토스트 메시지
            // $(window).trigger("toastshow", "선택하신 제품과 함께 비교할 수 있는 제품만 비교하기 버튼이 보여집니다");
          }
        } else {
          var leng = compareStorage[categoryId]["data"].length;
          if (leng < compareLimit) {
            compareStorage[categoryId]["data"].push(data);
          } else {
            $(window).trigger("excessiveCompareStorage");
            return false;
          }
        }

        // 세션스토리지에서 비교하기 데이터 전체 비교
        var prod_compare = compare.methodes.getStorage(compare.val.storageName);
        if (
          prod_compare.hasOwnProperty(categoryId) &&
          prod_compare[categoryId].data.length
        ) {
          var cateMapCheck = true;
          prod_compare[categoryId].data.forEach(function (item) {
            if (item.b2bcatemapping !== data.b2bcatemapping) {
              cateMapCheck = false;
              return false;
            }
          });

          if (!cateMapCheck) {
            void 0;
            return false;
          }
        }
        compare.methodes.setStorage(
          compare.val.storageName,
          compareStorage,
          true
        );

        return true;
      },
      removeCompareProd: function (categoryId, id) {
        var self = lgkorUI;
        if (id) {
          var compareStorage = compare.methodes.getStorage(
            compare.val.storageName
          );
          compareStorage[categoryId]["data"] = vcui.array.filter(
            compareStorage[categoryId]["data"],
            function (item) {
              return item["id"] != id;
            }
          );

          if (compareStorage[categoryId]["data"].length == 0) {
            compare.methodes.removeStorage(compare.val.storageName, categoryId);
          } else {
            var data = {};
            data[categoryId] = compareStorage[categoryId];
            compare.methodes.setStorage(
              compare.val.storageName,
              data,
              true,
              categoryId
            );
          }
        } else {
          compare.methodes.removeStorage(compare.val.storageName, categoryId);
        }
      },

      setStorage: function (key, value, isExtend, name) {
        var storage = localStorage.getItem(key);
        var storageData = storage ? JSON.parse(storage) : {};
        var data = { state: "set", key: key, value: value };
        //Internet Explorer 불가
        //storageData = Object.assign(storageData, value);
        if (isExtend) {
          $.extend(storageData, value);
        } else {
          storageData = value;
        }
        localStorage.setItem(key, JSON.stringify(storageData));
        sessionStorage.setItem(key, JSON.stringify(storageData));
        if (name) data = $.extend(data, { name: name });
        $(window).trigger(jQuery.Event("changeStorageData", data));

        return storageData;
      },

      getStorage: function (key, name) {
        var storage = localStorage.getItem(key);
        if (name) {
          var storageData = storage ? JSON.parse(storage) : {};
          return storageData[name];
        } else {
          return storage ? JSON.parse(storage) : {};
        }
      },

      removeStorage: function (key, name) {
        var data = {};
        var returnValue;
        var data = { state: "remove", key: key };
        if (name) {
          var storage = localStorage.getItem(key);
          var storageData = storage ? JSON.parse(storage) : {};
          delete storageData[name];
          sessionStorage.setItem(key, JSON.stringify(storageData));

          localStorage.setItem(key, JSON.stringify(storageData));

          returnValue = storageData;
          data = $.extend(data, { name: name });
        } else {
          sessionStorage.removeItem(key);

          localStorage.removeItem(key);

          returnValue = null;
          data = { state: "remove", key: key };
        }

        $(window).trigger(jQuery.Event("changeStorageData", data));

        // console.log("removeStorage data %o", data);

        $(window).trigger(jQuery.Event("changeStorageData", data));

        return returnValue;
      },
      setCompapreCookie: function (categoryId) {
        var self = lgkorUI;
        var compareIDs = [];
        var compareStorage = compare.methodes.getStorage(
          compare.val.storageName,
          categoryId
        );
        compareStorage["data"].forEach(function (item) {
          compareIDs.push(item.id + "|" + item.careType);
        }); // BTOCSITE-5938-545 care type 추가
        var compareCookie = compareIDs.join(",");

        self.setCookie(self.COMPARE_COOKIE_NAME, compareCookie);
      },
      gateCateCheck: function (type) {
        if ($(".pd-info-wrap").length > 0) {
          if (type === "btnType") {
            return false;
          }
          var count = 0;
          var ct = $(".pd-info-wrap").data("productInfo").categoryId;
          var storageCompare = compare.methodes.getStorage(
            compare.val.storageName
          );
          for (var item in storageCompare) {
            if (item === ct) {
              count++;
            }
          }
          if (count > 0) {
            if (type === "init") {
              compare.el.o4osmCompare
                .find(".ui_selectbox option")
                .each(function (idx) {
                  var $this = $(this);
                  if (ct === $this.val()) {
                    $this
                      .closest(".ui_selectbox")
                      .vcSelectbox("selectedIndex", idx);
                  }
                });
            }
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      },
    },
    bind: function ($this) {
      var compare = this;
      var doc = compare.el.doc;
      var toggleBtn = compare.el.toggleBtn;
      var tit = compare.el.title;
      var contents = compare.el.content;
      contents.css("overflow", "hidden");
      var speed = compare.val.popSpeed;
      var o4osmCompare = doc.find(".o4osm-compare");
      var comCount = 0;

      //버튼에 이벤트 할당
      doc.on("click", ".btn-compare, .btn-compare-etc", function (e) {
        e.preventDefault();
        var $this = $(this);
        var categoryId = $this.data("categoryId");
        var data;

        if ($this.closest(".btn-compare-etc").length > 0) {
          data = $this.closest(".pd-info-wrap").data("productInfo");
        } else {
          data = $this.closest("li").data("productInfo");
        }
        // if ($this.closest(".btn-compare-etc").length === 0) {
        $this.toggleClass("on");
        // }

        // PDP 비교하기 시 같이 선택
        // BTOCSITE-21440 사용자 세팅 정보가 자동으로 변경 start
        if (
          $(".pd-info-wrap").length > 0 &&
          $this.hasClass("btn-compare") &&
          $this.hasClass("on") &&
          compare.methodes.getStorage(
            compare.val.storageName,
            data.categoryId
          ) === undefined
        ) {
          compare.methodes.removeCompareProd(data.categoryId);
          doc.find(".btn-compare-etc").addClass("on");
          compare.methodes.setCompareState(
            $this.closest(".container").find(".btn-compare-etc"),
            $this
              .closest(".container")
              .find(".pd-info-wrap")
              .data("productInfo")
          );
          compare.methodes.setCompareState($this, data);
        } else {
          compare.methodes.setCompareState($this, data);
        }
        // compare.methodes.setCompareState($this, data);
        // BTOCSITE-21440 사용자 세팅 정보가 자동으로 변경 end
      });

      //초기화
      $this.find(".btn-reset").on("click", function (e) {
        compare.methodes.setClearCompare();
        compare.methodes.compareBtnStatus();
        $(window).trigger("toastshow", "비교하기 기능이 초기화되었습니다.");
      });

      // 팝업 열기 닫기
      toggleBtn.off("click").on("click", function () {
        if ($(this).hasClass("btn-open")) {
          compare.methodes.popOpen($this);
          o4osmCompare.prop('tabindex', 0);
          o4osmCompare.focus();
        } else {
          compare.methodes.popClose($this);
        }
      });

      // 다른 영역 클릭 시 팝업 닫기
      // $(document)
      //   .find(".wrap")
      //   .off("click")
      //   .on("click", function (e) {
      //     if (
      //       $(e.target).closest(".o4osm-compare").length < 1 &&
      //       $(e.target).text() !== "비교하기" &&
      //       $(e.target).text() !== "다른 제품과 비교하기"
      //     ) {
      //       if (toggleBtn.hasClass("btn-close")) {
      //         compare.methodes.popClose($this, speed);
      //       }
      //     }
      //   });

      //결과보기 버튼
      doc.on(
        "click",
        ".o4osm-compare-con > .btn-area > .btn-active",
        function (e) {
          e.preventDefault();

          var $uiSelectbox = o4osmCompare.find(".ui_selectbox");
          var categoryId;

          if ($uiSelectbox.is(":visible")) {
            categoryId = $uiSelectbox.vcSelectbox("value");
          } else {
            categoryId = Object.keys(
              compare.methodes.getStorage(compare.val.storageName)
            )[0];
          }
          var compareIDs = [];
          var compareStorage = compare.methodes.getStorage(
            compare.val.storageName,
            categoryId
          );

          compare.methodes.setCompapreCookie(categoryId);
          compareStorage["data"].forEach(function (item) {
            compareIDs.push(item.id + "|" + item.careType);
          });
          var compareCookie = {};
          compareCookie[categoryId] = compareIDs.join(",");

          lgkorUI.setCookie(
            "LG5_CompareCart_Selected",
            JSON.stringify(compareCookie)
          );

          var prodCompare = compare.methodes.getStorage("prod_compare");
          var prodCompareResult = {};

          for (key in prodCompare) {
            var inner = prodCompare[key].data;
            if (prodCompare[key].data.length > 1) {
              prodCompareResult[key] = "";
              for (key2 in inner) {
                var comma = key2 < inner.length - 1 ? "," : "";
                prodCompareResult[key] +=
                  inner[key2].id + "|" + inner[key2].careType + comma;
              }
            }
          }

          lgkorUI.setCookie(
            "LG5_CompareCart_All",
            JSON.stringify(prodCompareResult)
          );

          compare.val.willRemoveForCompare = true;
          compare.methodes.removeCompareProd(categoryId);

          var url =
            $(this).data("url") || "https://www.lge.co.kr/compare-products";
          if (url) {
            location.href = url;
          }
        }
      );

      //삭제버튼
      contents.on("click", ".pd .btn-close", function (e) {
        e.preventDefault();
        var $this = $(e.currentTarget);
        var data = $this.closest(".pd").data("pdInfoWrap");
        var $uiSelectbox = o4osmCompare.find(".ui_selectbox");
        var id = data.id;
        var categoryId = data.careType;
        o4osmCompare.data("selectId", categoryId);
        compare.methodes.removeCompareProd(categoryId, id);
        compare.methodes.compareBtnStatus();

        //마지막 삭제 시 팝업 닫기
        if (
          $this.closest(".pd-list-item").index() === 0 &&
          !doc.find(".pd-list-item").eq(1).is(":visible") &&
          doc.find(".o4osm-compare-category").is(":visible")
        ) {
          if (compare.methodes.gateCateCheck()) {
            compare.methodes.popClose(o4osmCompare);
          } else {
            compare.methodes.popHide(o4osmCompare);
          }
        }
      });

      $(window)
        .off("changeStorageData.compare")
        .on("changeStorageData.compare", function (e) {
          if (e.key === compare.val.storageName) {
            setTimeout(function () {
              var id = o4osmCompare.data("selectId");
              compare.methodes.setCompares(id || null);
              compare.methodes.setCompareStatus(id || null);
              compare.methodes.compareBtnStatus();
            }, 300);
          }
        })
        .on("excessiveCompareStorage", function () {
          compare.methodes.addToastAlert("excessive");
          compare.methodes.updateCompareButton();
          compare.methodes.compareBtnStatus();
        });
    },
    setProperty: function ($this) {
      this.el.o4osmCompare = $this;
      this.el.toggleBtn = $this.find(
        ".o4osm-compare-tit .btn-area > button:eq(1)"
      );
      this.el.title = $this.find(".o4osm-compare-tit");
      this.el.content = $this.find(".o4osm-compare-contents");
    },
    init: function () {
      var compare = this;
      $(document)
        .find(".o4osm-compare")
        .each(function () {
          var $this = $(this);
          //스토리지 데이터 없으면 안보이게 처리
          var storageCompare = compare.methodes.getStorage(
            compare.val.storageName
          );
          compare.setProperty($this);
          compare.bind($this);

          //qr 유입 처리
          $(window).on("compareInit", function () {
            if (
              etc.getParameterByName("compareType") === "PDP" || // PDP 유입
              etc.getParameterByName("compareType") === "WISH" // 위시리스트 유입
            ) {
              //파라미터 변경 최초 한번만 실행
              window.history.replaceState(
                "",
                "",
                vcui.uri.updateQueryParam(location.href, "compareType", "")
              );

              $(".btn-compare-etc").each(function () {
                var $this = $(this);
                var data = $this.closest(".pd-info-wrap").data("productInfo");
                $this.addClass("on");
                var isCompare = vcui.isEmpty(
                  compare.methodes.getStorage(
                    compare.val.storageName,
                    data.categoryId
                  )
                );

                if (isCompare) {
                  //카테고리 비었을 때
                  compare.methodes.setCompareState($this, data);
                } else {
                  //카테고리가 있지만 중복 되지 않을 때
                  var chkCount = 0;
                  compare.methodes
                    .getStorage(compare.val.storageName, data.categoryId)
                    .data.forEach(function (el) {
                      if (el.id == data.modelId) {
                        chkCount++;
                      }
                    });

                  if (chkCount === 0) {
                    compare.methodes.setCompareState($this, data);
                  }
                }
              });
            }

            compare.methodes.setCompares();
            compare.methodes.setCompareStatus(null, true);
            var isCompare = vcui.isEmpty(storageCompare);
            if (isCompare) {
              $this.hide();
            } else {
              if (compare.methodes.gateCateCheck("init")) {
                $this.show();
                compare.methodes.popMarginOn($this);
              }
            }
          });
        });
    },
    template: {
      compareSelect:
        "{{#each item in list}}" +
        '<option value="{{item.value}}" {{item.selected}}>{{item.label}} ({{item.count}}/2)</option> ' +
        "{{/each}}",
      similar:
        '<a href="{{url}}" class="similar-list">' +
        "<p>옆에 담은 제품과 같은<br> 카테고리 제품 리스트 보기 </p>" +
        "</a>",

      compare:
        '<button class="compare-close">' +
        "<span>비교하고 싶은 제품을<br>추가로 선택해주세요 </span>" +
        "</button>",

      compareCont:
        '<div class="pd">' +
        '<div class="img"><img src="{{productImg}}" alt=""></div>' +
        '<strong class="pd-name"><span class="main-title"><span class="main"><span class="blind">제품명</span>{{productName}}</span></span></strong>' +
        '<p class="pd-sku"><span class="blind">모델명</span>{{productID}}</p>' +
        '<button type="button" class="btn-close"><span class="blind">Close</span></button>' +
        "</div>",
    },
  };

  var etc = {
    loginChk: function (callBack, cancelBack, backLink, target) {
      var doc = $(document);
      var loginUrl = "/sso/member/login?state=";
      var moveUrl = backLink || location.pathname + location.search;

      // BTOCSITE-64387 공통(7/7) memberinfo, logininfo api 개선
        var isLogin = digitalData.userInfo.isLogin;
        if (!isLogin) {
          doc.find(".wishlist-box > input, .btn-wishlist").each(function () {
            var $this = $(this);
            if ($this.hasClass("btn-wishlist")) {
              $this.removeClass("is-active");
            } else {
              $this.prop("checked", false);
            }
          });
          lgkorUI.confirm("로그인 후 이용가능 합니다.<br>로그인하시겠어요? ", {
            title: "",
            cancelBtnName: "아니오",
            okBtnName: "네",
            cancel: function () {
              if (cancelBack !== undefined && cancelBack !== null) {
                cancelBack();
              }
            },
            ok: function () {
              location.href = vcui.uri.updateQueryParam(
                loginUrl,
                "state",
                encodeURIComponent(moveUrl)
              );
            },
          }, target); // BTOCSITE-77491 웹접근성
        } else {
          if (callBack !== undefined && callBack !== null) {
            callBack();
          }
        }
    },
    gateQrCall: function (target) {
      var doc = $(document);
      var qrChkUrl = "/mkt/api/bestshop/storemode/getPdpQrInfo";

      function isURL(barcode) {
        var expUrl = /^http[s]?\:\/\//i;
        return expUrl.test(barcode);
      }
      LGEAPPreturnSmComQRcode = function (qrUrl) {
        var urlChk = isURL(qrUrl);
        if (urlChk) {
          if (qrUrl.indexOf("/bestshop/storemode/gate/") > -1) {
            if (target !== undefined) {
              // 비교하기 qr
              var type = "";
              if ($(".total-wishlist").length > 0) {
                type = "WISH";
                // location.href = qrUrl + "&compareType=WISH";
              } else {
                type = "PDP";
                // location.href = qrUrl + "&compareType=PDP";
              }

              lgkorUI.requestAjaxDataPost(
                qrChkUrl,
                { url: qrUrl },
                function (result) {
                  if (result.data[0].isPdpExist === true) {
                    // 비교하기 값이 없을 때 팝업 호출
                    location.href = vcui.uri.updateQueryParam(
                      qrUrl,
                      "compareType",
                      type
                    );
                  } else {
                    $("#popup-o4osm-guide4").vcModal("show");
                  }
                }
              );
            } else if (doc.find(".o4o-store-main").length > 0) {
              location.href = qrUrl;
            } else {
              //하단 바 qr
              location.href = vcui.uri.updateQueryParam(
                qrUrl,
                "compareType",
                "DOC"
              );
              // location.href = qrUrl + "&compareType=DOC";
            }
          } else {
            $("#popup-o4osm-guide5").vcModal("show");
          }
        } else {
          $("#popup-o4osm-guide5").vcModal("show");
        }
      };

      // @신재민 대리님 비교하기 QR 호출 스크립트 입니다. ( 아이폰 command 와 안드로이는 호출 function 변경 )
      // 네이티브 QR스캔 영역 호출
      if (vcui.detect.isIOS) {
        var obj = {
          command: "scanSmComQRcode",
          callback: "LGEAPPreturnSmComQRcode",
        };
        var jsonString = JSON.stringify(obj);
        webkit.messageHandlers.callbackHandler.postMessage(jsonString);
      } else if (vcui.detect.isAndroid) {
        void android.openSmComQrScanner("LGEAPPreturnSmComQRcode");
      }
    },
    qrCall: function () {
      var doc = $(document);
      var contents = doc.find(".contents");
      var storeMapYn = contents.data("storeMapYn");
      var point = contents.data("myMembershipPoint") || "0";
      var storeName = contents.data("shopName");
      var storeId = contents.data("storeId");

      function isURL(barcode) {
        var expUrl = /^http[s]?\:\/\//i;
        return expUrl.test(barcode);
      }
      LGEAPPreturnSmQRcode = function (qrUrl) {
        var urlChk = isURL(qrUrl);
        if (urlChk) {
          if (qrUrl.indexOf("/bestshop/storemode/gate/") > -1) {
            location.href = qrUrl;
          } else {
            $("#popup-o4osm-guide5").vcModal("show");
          }
        } else {
          $("#popup-o4osm-guide5").vcModal("show");
        }
      };

      if (vcui.detect.isIOS) {
        var obj = {
          command: "scanSmQRcode",
          callback: "LGEAPPreturnSmQRcode",
          storeMapYn: storeMapYn,
          myMembershipPoint: point,
          shopname: storeName,
          storeId: storeId,
        };
        var jsonString = JSON.stringify(obj);
        webkit.messageHandlers.callbackHandler.postMessage(jsonString);
      } else if (vcui.detect.isAndroid) {
        void android.openSmQrScanner(
          "LGEAPPreturnSmQRcode",
          storeMapYn,
          point,
          storeName,
          storeId
        );
      }
    },
    historyBack: function () {
      var self = this;

      var referrer = document.referrer;
      var index = -1;
      var leng = lgkorUI.DOMAIN_LIST.length;
      for (var i = 0; i < leng; i++) {
        index = referrer.indexOf(lgkorUI.DOMAIN_LIST[i]);
        if (index > -1) {
          break;
        }
      }

      // BTOCSITE-3536 앱이고 파라메타에 openInApp 있는경우 closeInAppBrowser 실행
      if (isApp() && etc.getParameterByName("openMode") === "inAppBrowser") {
        if (vcui.detect.isIOS) {
          var jsonString = JSON.stringify({ command: "closeInAppBrowser" });
          webkit.messageHandlers.callbackHandler.postMessage(jsonString);
        } else {
          android.closeNewWebview();
        }
      } else {
        if (index < 0)
          location.href =
            "/bestshop/storemode/main?storeId=" +
            $(document)
              .find(".list-item.home > a")
              .attr("href")
              .split("storeId=")[1];
        //스토어모드 홈으로 이동
        else history.back();
      }
    },
    getParameterByName: function (name) {
      name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
      var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
      if (location.search === "") {
        results = regex.exec(location.hash);
      }
      return results == null
        ? ""
        : decodeURIComponent(results[1].replace(/\+/g, " "));
    },
    appInstallPop: function () {
      //최초 진입 시 앱설치 팝업
      var appPop = $(document).find("#popup-o4osm-guide1");
      if (
        !isApp() &&
        navigator.userAgent.toLocaleLowerCase().indexOf("kakaotalk") < 0
      ) {
        var cookie_name = "__LGAPP_DLOG_STORE__";
        if (vcui.Cookie.get(cookie_name) === "") {
          if (!!vcui.modal) {
            appPop.on("modalshow", function () {
              setTimeout(function () {
                appPop.blur();
              }, 300);
            });
            // BTOCSITE-25104 start
            /*appPop.on("modalhide", function () {
              if (
                vcui.Cookie.get("STORE_GUIDE") === "" &&
                $(document).find(".o4o-store-main").length > 0
              ) {
                // BTOCSITE-25104
                // etc.appGuidePop();
              }
            });*/
            //BTOCSITE-25104 end
            appPop.vcModal("show");
            appPop.find(".app-conts .btn").on("click", function () {
              goAppUrl(location.href);
              return;
            });
            appPop.find(".btn-see-web").one("click", function () {
              vcui.Cookie.set(cookie_name, "hide", { expires: 1, path: "/" });
              appPop.vcModal("close");
              return;
            });
          }
        }
      }
    },
    /*
    // BTOCSITE-25104 start
    appGuidePop: function () {
      var guidePop = $("#o4o-guide-popup");
      var guideSwiper = guidePop.find(".ui_carousel_slider");
      guidePop.on("modalhide", function () {
        $(window).off("resize.guide");
      });
      guidePop.on("modalshow", function () {
        $(window).on("resize.guide", function () {
          var innerHeight = window.innerHeight || $(window).height();
          guidePop.find(".slide-wrap,.slide-track").height(innerHeight);
        });
        $(window).trigger("resize.guide");
        setTimeout(function () {
          $("#o4o-guide-popup .ui_carousel_slider").on(
            "carouselbeforechange",
            function (e, data) {
              setTimeout(function () {
                // [BTOCSITE-21170] odr 가이드 페이지 인디게이터 타입 수정 start
                var pop = $("#o4o-guide-popup");
                var idx =
                  $(
                    "#o4o-guide-popup .ui_carousel_slider .ui_carousel_current.on"
                  ).index() + 1;
                if (pop.find(".slide-conts").length === idx) {
                  pop.find(".skip-guide").text("시작 하기");
                } else {
                  pop.find(".skip-guide").text("건너 뛰기");
                }
                // [BTOCSITE-21170] odr 가이드 페이지 인디게이터 타입 수정 end
              }, 100);
            }
          );
        }, 300);
        guideSwiper.vcCarousel("reinit");
      });
      guidePop.vcModal("show");
      guidePop.find(".skip-guide").one("click", function () {
        vcui.Cookie.set("STORE_GUIDE", "hide", { expires: 1, path: "/" });
        guidePop.vcModal("close");
        return;
      });
    },
    // BTOCSITE-25104 end
    */
    init: function () {},
  };

  var template = {
    gateProduct:
      '<div class="pd-util">' +
      '<span class="flag">{{flag}}</span>' +
      '<span class="date">가격 기준일 : {{date}}</span>' +
      "</div>" +
      '<dl class="pd-list">' +
      '<dt class="pd-tit">' +
      '<strong class="pd-name">{{modelDisplayName}}</strong>' +
      '<span class="pd-sku"><span class="blind">모델명</span>{{modelName}}</span>' +
      "</dt>" +
      '<dd class="pd-txt">' +
      '<div class="price">' +
      '<p class="original">' +
      '<strong class="blind">할인 전 정가 : </strong>' +
      "{{obsOriginalPrice}}<span>원</span>" +
      "</p>" +
      '<p class="total">' +
      '<strong class="blind">할인 후 판매가 : </strong>' +
      "{{obsTotalDiscountPrice}}<span>원</span>" +
      "</p>" +
      "</div>" +
      '<div class="pd-img">' +
      '<img src="{{smallImageAddr}}" alt="">' +
      "      </div>" +
      "   </dd>" +
      "</dl>",

    gateRecommendProduct:
      "<li>" +
      '<a href="{{pdpUrl}}" class="btn-goto-pd" data-contents="{{modelDisplayName}}/{{modelName}}">' +
      '<strong class="pd-name">{{modelDisplayName}}</strong>' +
      '<div class="img"><img src="{{smallImageUrl}}" alt=""></div>' +
      '<div class="pd-con1">' +
      '<p class="pd-sku"><span class="blind">모델명</span>{{modelName}}</p>' +
      '<div class="review-info">' +
      "{{#if rate > 0}}" +
      '<div class="star is-review"><span class="blind">리뷰있음</span></div>' +
      '<div class="average-rating"><span class="blind">평점</span>{{rate}}</div>' +
      "{{/if}}" +
      '{{#if reviewsCount !== "0" && reviewsCount !== ""}}' +
      '<div class="review-count"><span class="blind">리뷰 수</span>(<span>{{reviewsCount}}</span>)</div>' +
      "{{/if}}" +
      "</div>" +
      "</div>" +
      '<div class="price-area">' +
      '{{#if price !== "0"}}' +
      '<div class="price">' +
      '<span class="total">' +
      '<strong class="blind">판매가 : </strong>' +
      "{{price}}<span>원</span>" +
      "</span>&nbsp;" +
      '{{#if obsOriginalPrice !== "0"}}' +
      '<span class="original">' +
      '<strong class="blind">기존가격 : </strong>' +
      "{{obsOriginalPrice}}<span>원</span>" +
      "</span>" +
      "{{/if}}" +
      "</div>" +
      "{{/if}}" +
      "</div>" +
      '</a>' +
      '{{#if compareAvailYn == "Y"}}' +
      '<a href="#" class="btn-compare" data-model-id="{{modelId}}" data-contents="{{modelDisplayName}}/{{modelName}}">비교하기</a>' +
      "{{/if}}" +
      "</li>",

    gateSpec:
      "{{#each (item, idx) in this.stash}}" +
      "<li>" +
      '<strong class="list-tit">{{item.SPEC_NAME}}</strong>' +
      '<span class="list-txt">{{item.SPEC_VALUE_NAME}}</span>' +
      "</li>" +
      "{{/each}}",

    realTouch:
      "{{#each (item, idx) in this.stash}}" +
      '<div class="slide-conts ui_carousel_slide">' +
      '<iframe src="{{item.encurl}}" title="{{item.uspName}}"></iframe>' +
      "</div>" +
      "{{/each}}",

    wishTab:
      "{{#each (item, idx) in this.stash}}" +
      '<span class="tab-item">' +
      '<input type="checkbox" id="ch-a{{idx}}" data-wish-list-type-code="{{item.wishlistTypeCode}}" data-store-id="{{item.storeId}}">' +
      "{{#if idx === 0}}" +
      '<label for="ch-a{{idx}}">{{item.store}}</label>' +
      "{{#else}}" +
      '<label for="ch-a{{idx}}">#{{item.store}}</label>' +
      "{{/if}}" +
      "</span>&nbsp;" +
      "{{/each}}",

    wishListProduct:
      '<li data-ec-product="{{ga}}">' +
      '<div class="pd-info">' + 
      '<a href="{{pdpUrl}}" class="btn-goto-pd" data-contents="{{title}}/{{modelName}}">' +
      '{{#if bizType == "CARESOLUTION"}}' +
      '<div class="pd-badge" style="font-size:11px;font-weight:700;color:#ea1917;">' +
          '{{#if rentalCareType == "CR"}}' +
          '<span class="badge rental">UP 가전 2.0</span>' +
          '{{#else}}' +
          '<span class="badge rental">구독</span>' +
          '{{/if}}'+
      '</div>' +
      '{{/if}}' +
      '<span class="main-title"><span class="main"><span class="blind">제품명</span>{{modelDisplayNamePlusSpec}}</span></span>' +
      '<p class="pd-sku"><span class="blind">모델명</span>{{modelName}}</p>' +
      '<div class="pd-spec">' +
      '<span class="blind">주요스펙</span>'+
      "{{#each item in spec}}" +
      '<span class="spec-txt">{{item}}</span>' +
      "{{/each}}" +
      "</div>" +
      '<div class="img"><img src="{{imageUrl}}" alt=""></div>' +
      '{{#if price !== "0"}}' +
      '<div class="price-area">' +
      '<div class="price">' +
      '<p class="total">' +
      '<strong class="blind">판매가 : </strong>' +
      '{{#if bizType == "CARESOLUTION"}}월 {{/if}}{{price}}<span>원</span>' +
      "</p>" +
      "</div>" +
      "</div>" +
      "{{/if}}" +
      "</a>" +
      '{{#if compareAvailYn == "Y"}}' +
      '<a href="#" class="btn-compare" data-model-id="{{id}}" data-contents="{{title}}/{{modelName}}">비교하기</a>' +
      "{{/if}}" +
      "</div>" +
      '{{#if rentalCareType != "CR"}}' +
      '<div class="store-wrap">' +
      '<div class="store-util">' +
      // BTOCSITE-22519 위시리스트 수정요청(OO지점에 담겨 있습니다) start
      "{{#if pdLength === 1}}" +
      '<span><strong class="num on">{{storeList[0].name}}</strong>에 담겨 있습니다.</span>' +
      "{{#else}}" +
      '<span><strong class="num on">{{pdLength}}</strong>곳에 담겨 있습니다.</span>' +
      "{{/if}}" +
      // BTOCSITE-22519 위시리스트 수정요청(OO지점에 담겨 있습니다) end
      '<button type="button" class="btn-open"><span class="blind">펼쳐 보기</span></button>' +
      "</div>" +
      '<div class="store-list-wrap" style="display:block;">' +
      '<ul class="store-list">' +
      "{{#each item in storeList}}" +
      '<li class="store-list-item">' +
      "<dl>" +
      "<dt>" +
      '{{#if item.vrFlag}}<span class="add-vr">VR</span>{{/if}}' +
      '<span class="store-tit"><em class="blind">매장명</em>{{item.name}}</span><span class="date"><em class="blind">위시리스트에 추가 날짜</em>{{item.date}}</span>' +
      "</dt>" +
      '<dd class="btn-wrap">' +
      "{{#if item.disabled}}" +
      '{{#if item.modelStatusCode === "READY_FOR_SALE"}}<p class="txt-msg unsold">{{item.disabledReason}}</p>'+
      '{{#else}}<p class="txt-msg">{{item.disabledReason}}</p>' +
      '{{/if}}'+
      "{{#else}}" +
      '{{#if item.cart}}<button type="button" class="btn-cart" data-id="{{id}}" data-sku="{{sku}}" data-require-care="{{requireCare}}" data-type-flag="{{typeFlag}}" data-rt-seq="{{rtSeq}}" data-biz-type="{{bizType}}"><span>장바구니 담기</span></button>{{/if}}' +
      '{{#if item.memo}}<button type="button" class="btn-memo {{#if item.memoInfo.createDate !== ""}}active{{/if}}" data-href="#popup-memo" data-control="modal" data-wish-list-id="{{item.wishListId}}" data-memo-save="{{item.memoInfo.modifyUrl}}" data-memo-remove="{{item.memoInfo.removeUrl}}" data-memo-txt="{{item.memoInfo.content}}" data-memo-date="{{item.memoInfo.createDate}}" data-memo-id="{{item.memoInfo.noteId}}"><span>메모</span></button>{{/if}}' +
      '{{#if item.location}}<a href="{{item.locationUrl}}" class="btn-store-map" data-url="{{item.locationUrl}}" data-category-name="{{categoryName}}"><span>제품 위치 보기</span></a>{{/if}}' +
      "{{/if}}" +
      '<a href="{{item.resUrl}}" class="btn-reservation" data-url="{{item.resUrl}}"><span>매장 상담 예약</span></a>' +
      "</dd>" +
      "</dl>" +
      '<button type="button" class="btn-del" data-href="#popup-store-del" data-control="modal" data-id="{{id}}" data-wish-list-type-code="{{item.wishlistTypeCode}}" data-store-id="{{item.storeId}}"><span class="blind">삭제</span></button>' +
      "</li>" +
      "{{/each}}" +
      "</ul>" +
      "</div>" +
      "</div>" +
      '{{/if}}'+
      "</li>",
    // BTOCSITE-23820 start
    wishInfoAgree :
        '{{#if agreeYn === "Y"}}' +
        '<a href="#" data-agree="N" class="btn-link">개인정보 제3자 정보제공 동의 철회</a>'+
        "{{#else}}" +
        '<a href="#" data-agree="Y" class="btn-link">개인정보 제3자 정보제공 동의</a>'+
        "{{/if}}",
    // BTOCSITE-23820 end
    mapFloorTab:
      "{{#if Floor.length > 1}}" +
      '<div class="tabs-wrap ui_tab">' +
      '<ul class="tabs-floor">' +
      "{{#each item in Floor}}" +
      '<li><a href="#tab1_{{item.floorName}}"><span>{{item.floorName}}</span><em class="blind">선택됨</em></a></li>' +
      "{{/each}}" +
      "</ul>" +
      "</div>" +
      "{{/if}}",

    mapFloorCont:
      '<div class="tabs-wrap ui_tab" id="tab1_{{this.stash[0].floorName}}">' +
      '<ul class="tabs tabs-floor-pd">' +
      "{{#each (item, index) in this.stash}}" +
      "<li>" +
      '<a href="#tab2_{{item.floorName}}_{{index}}" data-map="{{item.imgUrl}}" data-store-name="{{item.storeName}}" data-floor-name="{{item.floorName}}" data-zone-Icon="{{item.zoneIcon}}" data-zone-Name="{{item.zoneName}}">' +
      '<span class="icon">' +
      '<img src="/lg5-common/images/CS/o4osm/icon_category_{{item.zoneIcon}}_off.svg" alt="">' +
      "</span>" +
      '{{item.zoneName}}<em class="blind">선택됨</em>' +
      "</a>" +
      "</li>" +
      "{{/each}}" +
      "</ul>" +
      "</div>",

    eventCont:
      '<li class="event-list-item">' +
      '<a href="#" data-url="{{imagePath}}">' +
      '<div class="e-img">' +
      '<img src="{{imageServerName}}" alt="{{imageAltText}}">' +
      "</div>" +
      '<div class="e-txt">' +
      '<div class="e-type">' +
      // '<span class="e-type1">{{storeFlag}}</span>' +
      '<span class="e-type2">{{eventTypeNm}}</span>' +
      "</div>" +
      '<p class="e-tit">{{eventName}}</p>' +
      '<p class="e-date">{{eventFromDate}}~{{eventToDate}}</p>' +
      "</div>" +
      "</a>" +
      "</li>",

    popularTab:
      "{{#each (item, idx) in this.stash}}" +
      '<span class="tab-item">' +
      '<input type="radio" id="r{{item.tabIdx}}-a{{idx}}" name="r{{item.tabIdx}}-a" data-category-name="{{item.categoryName}}" data-category-id="{{item.categoryId}}" data-detail-view-yn="{{item.detailViewYn}}">' +
      "{{#if idx === 0}}" +
      '<label for="r{{item.tabIdx}}-a{{idx}}">{{item.categoryName}}</label>' +
      "{{#else}}" +
      '<label for="r{{item.tabIdx}}-a{{idx}}">{{item.categoryName}}</label>' +
      "{{/if}}" +
      "</span>&nbsp;" +
      "{{/each}}",

    popularCont1:
      "{{#each (item, idx) in this.stash}}" +
      "<li>" +
      '<a href="{{item.pdpUrl}}" class="btn-goto-pd" data-contents="{{item.modelDisplayName}}/{{item.modelName}}">' +
      '<span class="ranking-num best-num"><span class="blind">랭킹</span>{{idx+1}}</span>' +
      '<span class="main-title"><span class="main"><span class="blind">제품명</span>{{item.modelDisplayNamePlusSpec}}</span></span>' +
      '<p class="pd-sku"><span class="blind">모델명</span>{{item.modelName}}</p>' +
      '<div class="img"><img src="{{item.smallImageUrl}}" alt="{{item.modelDisplayName}}"></div>' +
      '<div class="review-info">' +
      "{{#if item.rate > 0}}" +
      '<div class="star is-review"><span class="blind">리뷰있음</span></div>' +
      '<div class="average-rating"><span class="blind">평점</span>{{item.rate}}</div>' +
      "{{/if}}" +
      '{{#if item.reviewsCount !== "0" && item.reviewsCount !== ""}}' +
      '<div class="review-count"><span class="blind">리뷰 수</span>(<span>{{item.reviewsCount}}</span>)</div>' +
      "{{/if}}" +
      "</div>" +
      '<span class="wishlist-box">' +
      '<input type="checkbox" id="chk0{{item.tabIdx}}-0{{idx}}" {{#if item.wishYn === "Y"}}checked="checked" title="위시리스트 선택됨"{{/if}} data-model-id="{{item.modelId}}" data-contents="{{item.modelDisplayName}}/{{item.modelName}}">' +
      '<label for="chk0{{item.tabIdx}}-0{{idx}}"><span class="blind">찜하기 버튼</span></label>' +
      "</span>" +
      '</a>' +
      "</li>" +
      "{{/each}}",

    popularCont2:
      "<li {{#if idx > 2}}style='display:none'{{/if}}>" +
      '<a href="{{pdpUrl}}" class="btn-goto-pd" data-contents="{{modelDisplayName}}/{{modelName}}">' +
      '<span class="main-title"><span class="main"><span class="blind">제품명</span>{{modelDisplayNamePlusSpec}}</span></span>' +
      '<p class="pd-sku"><span class="blind">모델명</span>{{modelName}}</p>' +
      '<div class="img"><img src="{{smallImageUrl}}" alt=""></div>' +
      '<span class="wishlist-box">' +
      '<input type="checkbox" id="chk0{{tabIdx}}-{{idx+1}}" {{#if wishYn === "Y"}}checked="checked" title="위시리스트 선택됨"{{/if}} data-model-id="{{modelId}}" data-contents="{{modelDisplayName}}/{{modelName}}">' +
      '<label for="chk0{{tabIdx}}-{{idx+1}}"><span class="blind">찜하기 버튼</span></label>' +
      "</span>" +
      // '<a href="{{pdpUrl}}" class="btn-goto-pd" data-contents="{{modelDisplayName}}/{{modelName}}"><span class="blind" >{{modelDisplayName}}</span></a>' +
      '</a>' +
      "</li>",

    popularSubTab:
      "{{#each (item, idx) in this.stash}}" +
      "<li>" +
      '<a href="#pd_category{{idx}}" data-category-id="{{item.categoryId}}">' +
      '<span class="icon"><img src="/lg5-common/images/CS/o4osm/icon_category_{{item.categoryIcon}}_off.svg" alt=""></span> {{item.categoryName}}<em class="blind">선택됨</em>' +
      "</a>" +
      "</li>" +
      "{{/each}}",

    //qr 체크
    qrCheckPop:
      '<article id="popup-o4osm-guide2" class="popup-wrap small popup-o4osm-guide">' +
      '<header class="pop-header qr-code">' +
      '<h1 class="tit"><span>제품 QR코드 스캔 방법 안내</span></h1>' +
      "</header>" +
      '<section class="pop-conts no-footer">' +
      '<div class="o4osm-pop-conts">' +
      "<p>QR코드 스캔이 가능한 카메라 앱이나 (휴대폰 기본 카메라, 카카오톡, 네이버 앱 등) LGE.COM 앱으로 QR 스캔하여 편리하게 제품/혜택 정보를 확인해 보세요.</p>" +
      '<div class="btn-wrap column">' +
      '<a href="#" class="btn">LGE.COM 앱으로 QR스캔하기</a>' +
      '<a href="#" class="btn gray ui_modal_close">닫기</a>' +
      "</div>" +
      "</div>" +
      "</section>" +
      "</article>",

    //qr 인식 불가
    qrNoData:
      '<article id="popup-o4osm-guide5" class="popup-wrap small popup-o4osm-guide">' +
      '<header class="pop-header not-recognize">' +
      '<h1 class="tit"><span>QR코드 스캔 불가</span></h1>' +
      "</header>" +
      '<section class="pop-conts no-footer">' +
      '<div class="o4osm-pop-conts">' +
      "<p>인식할 수 없는 QR코드 입니다.<br>" +
      "베스트샵 매장 제품 가격표의 QR코드를 <br>스캔 해주세요.</p>" +
      '<div class="btn-wrap">' +
      '<a href="#" class="btn ui_modal_close">확인</a>' +
      "</div>" +
      "</div>" +
      "</section>" +
      "</article>",

    //제품정보 준비중
    notReady:
      '<article id="popup-o4osm-guide4" class="popup-wrap small popup-o4osm-guide">' +
      '<header class="pop-header qr-preparing">' +
      '<h1 class="tit"><span>제품정보 준비중</span></h1>' +
      "</header>" +
      '<section class="pop-conts no-footer">' +
      '<div class="o4osm-pop-conts">' +
      "<p>죄송합니다.<br>" +
      "제품 정보를 준비하는 중입니다. <br>" +
      "매장 매니저에게 문의 부탁드립니다.</p>" +
      '<div class="btn-wrap">' +
      '<a href="#" class="btn ui_modal_close">확인</a>' +
      "</div>" +
      "</div>" +
      "</section>" +
      "</article>",

    // BTOCSITE-23820 : 개인정보 제3자 제공동의 레이어
    infoAgreeLayer :
      "<!-- 개인정보 제3자 정보제공 동의 팝업 // -->"+
      '<article id="agreePrivacyPopup02" class="popup-wrap full">'+
        '<header class="pop-header">'+
          '<h1 class="tit"><span>개인정보 제3자 정보제공 동의</span></h1>'+
        '</header>'+
        '<section class="pop-conts priv-pop">'+
          '<div class="txt-cont">'+
            '<dl class="dl-txt-cont">'+
              '<dt>수집한 개인정보의 공유 및 제공</dt>'+
                '<dd>LG전자 주식회사는 포켓 베스트샵 서비스 운영을 위하여(매장에서의 제품 가격표 인식을 통한 편리한 매장상담 서비스 제공)<br>이용자의 개인정보를 LG전자 베스트샵으로 제공하고자 합니다.'+
              '</dd>'+
            '</dl>'+
            '<ul class="line-txt-cont">'+
              '<li id="linkPopup">'+
                '<strong>1. 개인정보를 제공 받는 자</strong>'+
                  '<p>LG전자 전문점 및 ㈜ 하이프라자</p>'+
                '<a href="#" data-url="https://kr.m.lgaccount.com/spx/terms/trustee-list1" class="btn-link">목록보기</a>'+
              '</li>'+
              '<li>'+
                '<strong>2. 개인정보 제공 항목</strong>'+
                '<p>LG전자 베스트샵에서의 제품 스캔 및 위시리스트 저장 정보</p>'+
              '</li>'+
              '<li>'+
                '<strong>3. 개인정보 제공목적</strong>'+
                '<p>매장과의 상담 진행 시 활용</p>'+
              '</li>'+
              '<li>'+
                '<strong>4. 개인정보의 보유 및 이용기간</strong>'+
                '<p>고객 개인정보 제공 철회 시 까지</p>'+
              '</li>'+
              '<li>'+
                '<strong>5. 동의 거부권 및 미동의에 대한 불이익 안내</strong>'+
                '<p>귀하께서는 위와 같은 개인정보 제 3자 제공에 동의하지 않을 권리가 있으나, 거부하신 경우 매장 상담 예약 신청이 제한됩니다.</p>'+
              '</li>'+
              '<li>'+
                '<strong>6. 이용 제한 대상만 14세 미만은 이용하실 수 없습니다.</strong>'+
              '</li>'+
            '</ul>'+
            '<p class="txt">위와 같이 정보 제공에 동의하십니까?</p>'+
          '</div>'+
        '</section>'+
        '<div  class="pop-footer center">'+
          '<div class="btn-group">'+
            '<button type="button" class="btn gray ui_modal_close"><span>취소</span></button>'+
            '<button type="button" class="btn pink btn-agree ui_modal_close"><span>동의</span></button>'+
          '</div>'+
        '</div>'+
        '<button type="button" class="btn-close ui_modal_close"><span class="blind">닫기</span></button>'+
      '</article>'+
      "<!-- // 개인정보 제3자 정보제공 동의 팝업 -->"
  };

  // BTOCSITE-23820 start
  var infoAgree = {
    storageKey : "store_info_agree",
    /*
      포켓 베스트샵 제3자정보 제공동의 여부 flow
      비로그인 상태
      1. 스토리지 체크 : 최초진입 또는 동의 취소한지 1일이 지난 경우 정보 제공 레이어 노출
      2. 정보 제공의 취소 버튼 > 스토리지에 저장 > QR인식 페이지로 이동
      3. 정보 제공의 동의 버튼 > 로그인 체크 > DB 회원 동의 여부 조회 > 레이어 노출 > DB 회원 동의 여부 저장 > QR인식 페이지로 이동
      4. 취소한지 1일이 안지난 경우 정보 제공동의 레이어 미노출 > QR인식 페이지로 이동

      로그인 상태
      1. 회원 동의여부 조회: 최초진입 또는 동의 취소한지 1일이 지난 경우 또는 미동의한 경우  레이어 노출
      2. 정보 제공의 동의 버튼 > DB 회원 동의 여부 저장 > 스토리지에 저장 > QR인식 페이지로 이동
      3. 정보 취소 버튼 클릭 > DB 회원 동의 여부 저장 > 스토리지에 저장 > QR인식 페이지로 이동
      4. 동의 했거나 취소한지 1일이 안지난 경우 정보 제공동의 레이어 미노출 > QR인식 페이지로 이동
     */

    //QR스캔 클릭시 제3자동의 여부 레이어 호출 init
    qrAgreeInit: function(openCont){
      
      // BTOCSITE-64387 공통(7/7) memberinfo, logininfo api 개선
        var isLogin = digitalData.userInfo.isLogin;
        var param = {"inflowType":"QR"};

        //로그인시
        if (isLogin) {

          //api 회원 동의여부 조회
          infoAgree.infoAgreeSelect(function(resultData){

            if(resultData ==null){
              infoAgree.agreeConfirm(isLogin,param, function(){
                // QR인식 페이지로 이동
                etc.gateQrCall(openCont);
              }, true);
            }else if(resultData !==null && resultData.agreeYn === "N"){
              var agreeDate = resultData.agreeDate;
              var expires = infoAgree.convertDate(agreeDate);
              var diff = vcui.date.diff(expires, new Date());

              if(parseInt(diff.days) > 0){
                infoAgree.agreeConfirm(isLogin,param,function(){
                  // QR인식 페이지로 이동
                  etc.gateQrCall(openCont);
                }, true);

              }else{
                etc.gateQrCall(openCont);
              }

            }else {
               etc.gateQrCall(openCont);
            }

          }, isLogin);

        }else{
          //비로그인시
          if(infoAgree.isStorageCheck()){
            etc.gateQrCall(openCont);
          }else{
            //최초진입 또는 동의 취소한지 1일이 지난 경우 레이어 노출
            infoAgree.agreeConfirm(isLogin, param,function(){
              // QR인식 페이지로 이동
              etc.gateQrCall(openCont);
            },true);
          }
        }
    },

    //위시리스트 제3자동의 여부 레이어 호출 init
    wishAgreeTemplateInit : function(){
      infoAgree.infoAgreeSelect(function(result){
        if(result !== null){
          infoAgree.wishAppendTemp(result);
        }else{
          infoAgree.wishAppendTemp({"agreeYn":"N"});
        }
      });
    },

    //게이트페이지 3자 정보동의 레이어
    gatepageAgreeConfirm : function(isLogin,param, callback){
      var that = this;
      $("#agreePrivacyPopup02").vcModal("show");
      var btnDom = $('#agreePrivacyPopup02').find('.pop-footer .btn-group').children('button');

      var data = {};
      if(param !== undefined && param !== null){
        var data = param;
      }
        //취소 버튼
      btnDom.eq(0).off().on('click', function(e){
        data.agreeYn="N";
        infoAgree.setAgree(isLogin,null,callback,data);
      })

      //동의버튼
      btnDom.eq(1).off().on('click', function(e){
        data.agreeYn="Y";
        infoAgree.setAgree(isLogin,null,callback,data);
      })
    },

    //QR스캔 클릭시 & pdp 위시리스트 클릭시 제3자 정보 제공 동의 레이어 노출 함수
    agreeConfirm : function(isLogin, param, callback, isCancel){
      var that = this;
      $("#agreePrivacyPopup02").vcModal("show");
      var btnDom = $('#agreePrivacyPopup02').find('.pop-footer .btn-group').children('button');

      if(isCancel){
        //취소 버튼
        btnDom.eq(0).off().on('click', function(e){
          infoAgree.setCancel(isLogin,callback,param);
        })
      }

      //동의버튼
      btnDom.eq(1).off().on('click', function(e){
        param.agreeYn="Y";
        infoAgree.setAgree(isLogin,null,callback,param);
      })
    },

    //위시리스트 제3자 정보동의 철회 레이어
    wishAgreeCancleConfirm : function(){
      var that = this;
      lgkorUI.confirm("개인정보 제3자 정보 제동에 대한 <br>동의를 철회 하시겠습니까?", {
        title: "",
        cancelBtnName: "취소",
        okBtnName: "철회",
        ok: function () {
          that.setCancel(true, function(data){
            infoAgree.wishAgreeCallback(data);
          },{"inflowType":"WISH"});
        },
      }, $('#infoagree').find('a')); // BTOCSITE-77491 웹접근성
    },

    //위시리스트 제3자 정보동의 템플릿 append
    wishAppendTemp : function(data){
      $('#infoagree').find('a').remove();
      $('#infoagree').append(vcui.template(template.wishInfoAgree, data));

      //위시리스트 동의하기 클릭이벤트 등록
      $('#infoagree').find('a').on('click', function(e){
        var $this = $(e.currentTarget);
        var agree = $this.data("agree");

        if(agree === 'Y'){
          infoAgree.agreeConfirm(true, {"inflowType":"WISH"}, function(data){
            infoAgree.wishAgreeCallback(data);
          },false);
        }else{
          infoAgree.wishAgreeCancleConfirm();
        }
      });
    },

    //위시리스트 콜백 함수
    wishAgreeCallback : function(data){
      if(data !== undefined && data !== null){
        infoAgree.wishAppendTemp(data);
      }
    },

    //동의 하기 버튼클릭
    setAgree : function(isLogin, backLink, callBack, data){

      //로그인 체크
      if(isLogin){
        // DB 회원 동의 여부 저장
        infoAgree.infoAgreeModify(data,callBack);

      }else{
        // 로그인
        var loginUrl = "/sso/member/login?state=";
        var moveUrl = backLink || location.pathname + location.search;
        lgkorUI.confirm("로그인 후 이용가능 합니다.<br>로그인하시겠어요? ", {
          title: "",
          cancelBtnName: "아니오",
          okBtnName: "네",
          ok: function () {
            var returnUrl = vcui.uri.addParam(moveUrl, { 'agree' : 'Y' });
            location.href = vcui.uri.updateQueryParam(
                loginUrl,
                "state",
                encodeURIComponent(returnUrl)
            );
          },
        });
      }
    },

    //최소 하기 버튼클릭
    setCancel : function (isLogin, callBack, param) {

      var data = {"agreeYn":"N"};

      if(isLogin){
        // DB 회원 동의 여부 저장
        data = Object.assign(data,param);
        infoAgree.infoAgreeModify( data, callBack);
      }else{
        // 스토리지에 저장
        infoAgree.setStorage(data);

        if (callBack !== undefined && callBack !== null) {
          callBack();
        }
      }
    },

    //제3자동의여부 저장 api
    infoAgreeModify : function(param, callBack){

      try{
        lgkorUI.requestAjaxDataPost("/mkt/api/bestshop/storemode/info/agree", param, function (result) {
          var success = result.success;

          if(success){
            //비로그인시를 위해 스토리지에 저장
            infoAgree.setStorage({"agreeYn" : result.data.agreeYn});

            if (callBack !== undefined && callBack !== null) {
              callBack(result.data);
            }
          }else{
            infoAgree.apiFailCallback(result.data.agreeYn);
          }
        });

      }catch (e) {
        infoAgree.apiFailCallback(param.agreeYn);
      }
    },

    //오류시 callback 함수
    apiFailCallback: function(agreeYn){
      if(agreeYn === 'Y'){
        alert('개인정보 제3자 정보제공 동의가 정상적으로 저장되지 않았습니다.')
      }else{
        alert('개인정보 제3자 정보제공 동의 철회가 정상적으로 저장되지 않았습니다.')
      }
    },

    //제3자동의여부 조회 api
    infoAgreeSelect : function(callBack, isLogin){
      lgkorUI.requestAjaxDataPost("/mkt/api/bestshop/storemode/info/getAgree", {}, function (result) {

        if (callBack !== undefined && callBack !== null) {
          callBack(result.data, isLogin);
        }
      });
    },

    //스토리지에 현재 날짜로 동의 여부 넣기
    setStorage: function(data){
      localStorage.removeItem(infoAgree.storageKey);

      var today = new Date();
      var year = today.getFullYear().toString();
      var month = (today.getMonth()+1).toString();
      var day = today.getDate().toString();
      var date = day.length > 1?day:"0"+day;

      data.expires =(year+month+date);
      localStorage.setItem(infoAgree.storageKey, JSON.stringify(data));
    },

    //스토리지 체크
    isStorageCheck : function(){
      var result = false,
          storage = localStorage.getItem(infoAgree.storageKey);
    // var smCid = vcui.Cookie.get("SM_CID"); //QR 로그의 sm_cid

      if(!vcui.isEmpty(storage)){
          var storageData = JSON.parse(storage);

          if(storageData.expires !=="" && storageData.expires !==null && storageData.expires !== undefined){
            var expires = infoAgree.convertDate(storageData.expires);
            var diff = vcui.date.diff(expires, new Date());

            // 취소한지 1일 지나지 않거나 동의 함.
            if(parseInt(diff.days) == 0 || storageData.agreeYn === 'Y') result = true;

          }
      }
      return result;
    },

    //날짜 변환
    convertDate : function(days) {
      if (days instanceof Date) {
        return days
      } else if (typeof days === 'string') {
        return infoAgree.formatDate(days);
      }else{
        return "";
      }
    },

    //날짜 포맷
    formatDate : function(date){
      var yyyy = date.substr(0, 4),
          mm = date.substr(4, 2),
          dd = date.substr(6, 2);
      return new Date(yyyy,mm-1,dd);
    },

    returnUrl : function(callBack){
      var reUrl = location.href.replace("&agree=Y","")
          .replace("agree=Y&","")
          .replace("&agree=Y&","");

      window.history.replaceState(
          "",
          "",
          reUrl
      );

      if (callBack !== undefined && callBack !== null) {
        callBack();
      }
    }
  };

  var wishList = {
    //위시리스트 등록
    addWish : function ($this,modelId,storeId) {
      var param = {
        type: "add",
        modelId: modelId,
        wishType: "10",
        storeId: storeId,
      };

      wishList.wishListApi(param, function () {
        $this.addClass("is-active").attr("title","위시리스트 선택됨");
        $(window).trigger(
            "toastshow",
            "선택하신 제품이 위시리스트에 추가되었습니다."
        );
      });
    },

    //위시리스트 삭제
    removeWish : function ($this,modelId,storeId) {
      var param = {
        type: "remove",
        modelId: modelId,
        wishType: "10",
        storeId: storeId
      }

      wishList.wishListApi(param, function () {
        $this.removeClass("is-active").removeAttr("title");
        $(window).trigger(
            "toastshow",
            "선택하신 제품이 위시리스트에서 삭제되었습니다."
        );
        //위시리스트 삭제 시 메모 삭제
        $(".btn-memo").each(function () {
          var $this = $(this);
          $this.attr({
            "data-memo-txt": "",
            "data-memo-date": "",
            "data-memo-id": "",
            "data-note-list-flag": "N",
          });
          $this.removeClass("active");
        });
      });
    },

    //위시리스트 api 호출
    wishListApi : function ( param, callback) {
      lgkorUI.requestAjaxDataPost("/mkt/api/bestshop/storemode/wishlist/modifyWishlist",param,
        function (result) {

          if (callback !== undefined && callback !== null) {
            callback();
          }
        }
      );
    }
  }
  // BTOCSITE-23820 end
  // S : BTOCSITE-82760 전자가격표 QR 입력 시 랜딩되는 포켓베스트샵 페이지 케어서비스 영상 추가 개발 요청
  var videoPop = {
    init: function () {
      $('.popup-o4osm-video').each(function() {
        var $this = $(this);
        $this.on("modalshow", function (e, i) {
          var videoCapBtn =   $('.popup-o4osm-video .btn-video');
          var videoCapCloseBtn =  $('.popup-o4osm-video .btn-video-close');
    
          // 동영상 설명 보기
          videoCapBtn.off('click').on('click', function(){
              var videoCapOpenBtnLabel = $(this).attr('data-open');
              var videoCapCloseBtnLabel = $(this).attr('data-close');
    
              if( $(this).hasClass('on') ){
                  $(this).removeClass('on');
                  $(this).parents('.visual-area').find('.video-cap-section').hide();
                  if( $(this).parents('.youtube-box').length || $(this).parents('.embed-box').length ) {
                      $(this).text(videoCapOpenBtnLabel);
                  }   
              }else{
                  $(this).addClass('on');
                  $(this).parents('.visual-area').find('.video-cap-section').show();
                  $(this).parents('.visual-area').find('.video-cap-section').focus();
                  if( $(this).parents('.youtube-box').length || $(this).parents('.embed-box').length ) {
                      $(this).text(videoCapCloseBtnLabel);
                  }
              }
          })
      
          // 동영상 설명 닫기
          videoCapCloseBtn.off('click').on('click', function(){
            $(this).parents('.visual-area').find('.video-cap-section').hide();
            $(this).parents('.visual-area').find('.video-caption-wrap .btn-video').removeClass('on');
            $(this).parents('.visual-area').find('.video-caption-wrap .btn-video').focus();
          })
        });

        $this.on("modalhide", function (e) {
          var $target = $(e.target);

          $target.find('video').each(function() {
            var $this = $(this);

            $this.get(0).pause();
            $this.get(0).currentTime = 0;
          });
        });
      });

     
    },

  };
  // E : BTOCSITE-82760 전자가격표 QR 입력 시 랜딩되는 포켓베스트샵 페이지 케어서비스 영상 추가 개발 요청
  $(document).on("DOMContentLoaded", function () {
    var doc = $(document);

    // BTOCSITE-64387 공통(7/7) memberinfo, logininfo api 개선
    doc.find(".container").data("loginCheck", digitalData.userInfo.isLogin);
    
    init();
  });
})();